/* eslint-disable */
import { DocumentTypeDecoration } from "@graphql-typed-document-node/core";
export type Maybe<T> = T | null;
export type InputMaybe<T> = Maybe<T>;
export type Exact<T extends { [key: string]: unknown }> = { [K in keyof T]: T[K] };
export type MakeOptional<T, K extends keyof T> = Omit<T, K> & { [SubKey in K]?: Maybe<T[SubKey]> };
export type MakeMaybe<T, K extends keyof T> = Omit<T, K> & { [SubKey in K]: Maybe<T[SubKey]> };
export type MakeEmpty<T extends { [key: string]: unknown }, K extends keyof T> = { [_ in K]?: never };
export type Incremental<T> = T | { [P in keyof T]?: P extends " $fragmentName" | "__typename" ? T[P] : never };
/** All built-in and custom scalars, mapped to their actual values */
export type Scalars = {
    ID: { input: string; output: string };
    String: { input: string; output: string };
    Boolean: { input: boolean; output: boolean };
    Int: { input: number; output: number };
    Float: { input: number; output: number };
};

export type Api = {
    __typename?: "API";
    apiKeys?: Maybe<Array<ApiKey>>;
    clientId?: Maybe<Scalars["String"]["output"]>;
};

export type ApiKey = {
    __typename?: "APIKey";
    createdAt?: Maybe<Scalars["Float"]["output"]>;
    expiresAt?: Maybe<Scalars["Float"]["output"]>;
    id?: Maybe<Scalars["String"]["output"]>;
    name?: Maybe<Scalars["String"]["output"]>;
    value?: Maybe<Scalars["String"]["output"]>;
};

export type Address = {
    __typename?: "Address";
    city?: Maybe<Scalars["String"]["output"]>;
    country?: Maybe<Scalars["String"]["output"]>;
    line1?: Maybe<Scalars["String"]["output"]>;
    line2?: Maybe<Scalars["String"]["output"]>;
    postalCode?: Maybe<Scalars["String"]["output"]>;
};

export type AddressInput = {
    city?: InputMaybe<Scalars["String"]["input"]>;
    country?: InputMaybe<Scalars["String"]["input"]>;
    line1?: InputMaybe<Scalars["String"]["input"]>;
    line2?: InputMaybe<Scalars["String"]["input"]>;
    postalCode?: InputMaybe<Scalars["String"]["input"]>;
};

export type Agreement = {
    __typename?: "Agreement";
    currentRevision?: Maybe<AgreementRevision>;
    currentRevisionIndex?: Maybe<Scalars["Int"]["output"]>;
    id?: Maybe<Scalars["String"]["output"]>;
    latestRevisionIndex?: Maybe<Scalars["Int"]["output"]>;
    name?: Maybe<Scalars["String"]["output"]>;
    revisions?: Maybe<Array<AgreementRevision>>;
    type?: Maybe<AgreementType>;
};

export type AgreementRevision = {
    __typename?: "AgreementRevision";
    agreementId?: Maybe<Scalars["String"]["output"]>;
    content?: Maybe<RichText>;
    createdAt?: Maybe<Scalars["Float"]["output"]>;
    index?: Maybe<Scalars["Int"]["output"]>;
    isOptional?: Maybe<Scalars["Boolean"]["output"]>;
    isPreselected?: Maybe<Scalars["Boolean"]["output"]>;
    label?: Maybe<Scalars["String"]["output"]>;
};

export type AgreementRevisionInput = {
    content?: InputMaybe<RichTextInput>;
    isOptional?: InputMaybe<Scalars["Boolean"]["input"]>;
    isPreselected?: InputMaybe<Scalars["Boolean"]["input"]>;
    label?: InputMaybe<Scalars["String"]["input"]>;
};

export const AgreementType = {
    Pp: "pp",
    Signup: "signup",
    Tos: "tos",
} as const;

export type AgreementType = (typeof AgreementType)[keyof typeof AgreementType];
export type BlacklistHistoryRecord = {
    __typename?: "BlacklistHistoryRecord";
    action?: Maybe<Scalars["String"]["output"]>;
    durationHours?: Maybe<Scalars["Int"]["output"]>;
    message?: Maybe<Scalars["String"]["output"]>;
    performedAt?: Maybe<Scalars["Float"]["output"]>;
    performedBy?: Maybe<CognitoUser>;
    reason?: Maybe<Scalars["String"]["output"]>;
};

export type Campaign = {
    __typename?: "Campaign";
    applications?: Maybe<CampaignApplicationItems>;
    attachments?: Maybe<Array<CampaignAttachment>>;
    client?: Maybe<Client>;
    clientNote?: Maybe<Scalars["String"]["output"]>;
    delivery?: Maybe<CampaignDelivery>;
    description?: Maybe<RichText>;
    displayTenants?: Maybe<Array<Tenant>>;
    id?: Maybe<Scalars["String"]["output"]>;
    images?: Maybe<Array<CampaignImage>>;
    isHidden?: Maybe<Scalars["Boolean"]["output"]>;
    isTopped?: Maybe<Scalars["Boolean"]["output"]>;
    mainTenant?: Maybe<Tenant>;
    milestones?: Maybe<Array<CampaignMilestone>>;
    name?: Maybe<Scalars["String"]["output"]>;
    outcome?: Maybe<CampaignOutcome>;
    pricing?: Maybe<CampaignPricing>;
    productReviewDestinations?: Maybe<Array<ProductReviewDestination>>;
    products?: Maybe<Array<Product>>;
    questionnaire?: Maybe<Questionnaire>;
    restrictions?: Maybe<CampaignRestrictions>;
    results?: Maybe<CampaignResults>;
    resultsExportJobs?: Maybe<Array<ExportJob>>;
    reviews?: Maybe<ReviewItems>;
    selectedApplicationsCount?: Maybe<Scalars["Int"]["output"]>;
    settings?: Maybe<CampaignSettings>;
    slug?: Maybe<Scalars["String"]["output"]>;
    state?: Maybe<CampaignState>;
    tags?: Maybe<Array<CampaignTag>>;
    tenant?: Maybe<Tenant>;
    thumbnailImage?: Maybe<File>;
    totalApplicationsCount?: Maybe<Scalars["Int"]["output"]>;
    unresolvedApplicationsCount?: Maybe<Scalars["Int"]["output"]>;
};

export type CampaignApplicationsArgs = {
    limit?: InputMaybe<Scalars["Int"]["input"]>;
    nextToken?: InputMaybe<Scalars["String"]["input"]>;
    reviewer?: InputMaybe<Array<Scalars["String"]["input"]>>;
    state?: InputMaybe<Array<CampaignApplicationState>>;
};

export type CampaignResultsExportJobsArgs = {
    clientId: Scalars["String"]["input"];
};

export type CampaignReviewsArgs = {
    limit?: InputMaybe<Scalars["Int"]["input"]>;
    nextToken?: InputMaybe<Scalars["String"]["input"]>;
    productId?: InputMaybe<Scalars["String"]["input"]>;
    state?: InputMaybe<Array<ReviewState>>;
};

export type CampaignApplication = {
    __typename?: "CampaignApplication";
    appliedAt?: Maybe<Scalars["Float"]["output"]>;
    campaign?: Maybe<Campaign>;
    deadlineAt?: Maybe<Scalars["Float"]["output"]>;
    deliveryAddress?: Maybe<Address>;
    deliveryConfirmedAt?: Maybe<Scalars["Float"]["output"]>;
    discountCode?: Maybe<Scalars["String"]["output"]>;
    dueReviewNotificationsAt?: Maybe<Array<Scalars["Float"]["output"]>>;
    id?: Maybe<Scalars["String"]["output"]>;
    isDelivered?: Maybe<Scalars["Boolean"]["output"]>;
    isUnselected?: Maybe<Scalars["Boolean"]["output"]>;
    latestResolution?: Maybe<CampaignApplicationResolution>;
    pendingResolution?: Maybe<CampaignApplicationResolution>;
    questionnaireResponse?: Maybe<QuestionnaireResponse>;
    resolutions?: Maybe<Array<CampaignApplicationResolution>>;
    reviewer?: Maybe<Reviewer>;
    state?: Maybe<CampaignApplicationState>;
    submittedReviewsCount?: Maybe<Scalars["Int"]["output"]>;
};

export type CampaignApplicationItems = {
    __typename?: "CampaignApplicationItems";
    items?: Maybe<Array<CampaignApplication>>;
    nextToken?: Maybe<Scalars["String"]["output"]>;
};

export type CampaignApplicationResolution = {
    __typename?: "CampaignApplicationResolution";
    message?: Maybe<Scalars["String"]["output"]>;
    resolvedAt?: Maybe<Scalars["Float"]["output"]>;
    resolvedBy?: Maybe<User>;
    status?: Maybe<CampaignApplicationResolutionStatus>;
};

export const CampaignApplicationResolutionStatus = {
    Alternate: "alternate",
    Rejected: "rejected",
    Selected: "selected",
} as const;

export type CampaignApplicationResolutionStatus =
    (typeof CampaignApplicationResolutionStatus)[keyof typeof CampaignApplicationResolutionStatus];
export const CampaignApplicationState = {
    Draft: "draft",
    Pending: "pending",
    Resolved: "resolved",
    Submitted: "submitted",
} as const;

export type CampaignApplicationState = (typeof CampaignApplicationState)[keyof typeof CampaignApplicationState];
export type CampaignAttachment = {
    __typename?: "CampaignAttachment";
    file?: Maybe<File>;
    originalFilename?: Maybe<Scalars["String"]["output"]>;
};

export type CampaignAttachmentInput = {
    file?: InputMaybe<FileInput>;
    originalFilename?: InputMaybe<Scalars["String"]["input"]>;
};

export type CampaignDelivery = {
    __typename?: "CampaignDelivery";
    freeOfCharge?: Maybe<Scalars["Boolean"]["output"]>;
    instructions?: Maybe<RichText>;
    notes?: Maybe<Scalars["String"]["output"]>;
    type?: Maybe<Scalars["String"]["output"]>;
};

export type CampaignDeliveryInput = {
    freeOfCharge?: InputMaybe<Scalars["Boolean"]["input"]>;
    instructions?: InputMaybe<RichTextInput>;
    notes?: InputMaybe<Scalars["String"]["input"]>;
    type?: InputMaybe<Scalars["String"]["input"]>;
};

export type CampaignDiscountCode = {
    __typename?: "CampaignDiscountCode";
    code?: Maybe<Scalars["String"]["output"]>;
    reviewer?: Maybe<Reviewer>;
};

export type CampaignDiscountCodeItems = {
    __typename?: "CampaignDiscountCodeItems";
    items?: Maybe<Array<CampaignDiscountCode>>;
    nextToken?: Maybe<Scalars["String"]["output"]>;
};

export type CampaignImage = {
    __typename?: "CampaignImage";
    file?: Maybe<File>;
    isThumbnail?: Maybe<Scalars["Boolean"]["output"]>;
};

export type CampaignImageInput = {
    file?: InputMaybe<FileInput>;
};

export type CampaignInquiry = {
    __typename?: "CampaignInquiry";
    additionalNotes?: Maybe<Scalars["String"]["output"]>;
    client?: Maybe<Client>;
    createdAt?: Maybe<Scalars["Float"]["output"]>;
    delivery?: Maybe<CampaignDelivery>;
    description?: Maybe<RichText>;
    displayTenants?: Maybe<Array<Tenant>>;
    id?: Maybe<Scalars["String"]["output"]>;
    images?: Maybe<Array<CampaignImage>>;
    mainTenant?: Maybe<Tenant>;
    name?: Maybe<Scalars["String"]["output"]>;
    outcome?: Maybe<CampaignOutcome>;
    pricing?: Maybe<CampaignPricing>;
    products?: Maybe<Array<CampaignInquiryProduct>>;
    questionnaire?: Maybe<Questionnaire>;
    restrictions?: Maybe<CampaignRestrictions>;
    settings?: Maybe<CampaignInquirySettings>;
    tags?: Maybe<Array<CampaignTag>>;
    tenant?: Maybe<Tenant>;
    thumbnailImage?: Maybe<File>;
};

export type CampaignInquiryItems = {
    __typename?: "CampaignInquiryItems";
    items?: Maybe<Array<CampaignInquiry>>;
    nextToken?: Maybe<Scalars["String"]["output"]>;
};

export type CampaignInquiryProduct = {
    __typename?: "CampaignInquiryProduct";
    attributes?: Maybe<Array<ProductAttribute>>;
    category?: Maybe<ProductCategory>;
    description?: Maybe<RichText>;
    destinations?: Maybe<Array<Maybe<ReviewDestination>>>;
    detailPageLinks?: Maybe<Array<ProductLink>>;
    ean?: Maybe<Scalars["String"]["output"]>;
    id?: Maybe<Scalars["String"]["output"]>;
    images?: Maybe<Array<File>>;
    info?: Maybe<CampaignInquiryProductInfo>;
    key?: Maybe<Scalars["String"]["output"]>;
    name?: Maybe<Scalars["String"]["output"]>;
    reviewFocusInstructions?: Maybe<RichText>;
    thumbnailImage?: Maybe<File>;
    userManualLink?: Maybe<Scalars["String"]["output"]>;
};

export type CampaignInquiryProductInfo = {
    __typename?: "CampaignInquiryProductInfo";
    manufacturer?: Maybe<Scalars["String"]["output"]>;
    model?: Maybe<Scalars["String"]["output"]>;
};

export type CampaignInquiryProductInfoInput = {
    manufacturer?: InputMaybe<Scalars["String"]["input"]>;
    model?: InputMaybe<Scalars["String"]["input"]>;
};

export type CampaignInquiryProductInput = {
    attributes?: InputMaybe<Array<ProductAttributeInput>>;
    category?: InputMaybe<ProductCategoryInput>;
    description?: InputMaybe<RichTextInput>;
    destinations?: InputMaybe<Array<ReviewDestinationInput>>;
    detailPageLinks?: InputMaybe<Array<ProductLinkInput>>;
    ean?: InputMaybe<Scalars["String"]["input"]>;
    id?: InputMaybe<Scalars["String"]["input"]>;
    images?: InputMaybe<Array<FileInput>>;
    info?: InputMaybe<CampaignInquiryProductInfoInput>;
    key?: InputMaybe<Scalars["String"]["input"]>;
    name?: InputMaybe<Scalars["String"]["input"]>;
    reviewFocusInstructions?: InputMaybe<RichTextInput>;
    thumbnailImage?: InputMaybe<FileInput>;
    userManualLink?: InputMaybe<Scalars["String"]["input"]>;
};

export type CampaignInquirySettings = {
    __typename?: "CampaignInquirySettings";
    capacity?: Maybe<Scalars["Int"]["output"]>;
    openAt?: Maybe<Scalars["Float"]["output"]>;
};

export type CampaignInquirySettingsInput = {
    capacity?: InputMaybe<Scalars["Int"]["input"]>;
    openAt?: InputMaybe<Scalars["Float"]["input"]>;
};

export type CampaignItems = {
    __typename?: "CampaignItems";
    items?: Maybe<Array<Campaign>>;
    nextToken?: Maybe<Scalars["String"]["output"]>;
};

export type CampaignMilestone = {
    __typename?: "CampaignMilestone";
    timestamp?: Maybe<Scalars["Float"]["output"]>;
    type?: Maybe<Scalars["String"]["output"]>;
};

export type CampaignOutcome = {
    __typename?: "CampaignOutcome";
    fbMentions?: Maybe<Array<Scalars["String"]["output"]>>;
    hashtags?: Maybe<Array<Scalars["String"]["output"]>>;
    igMentions?: Maybe<Array<Scalars["String"]["output"]>>;
    includeImages?: Maybe<Scalars["Boolean"]["output"]>;
    includeSocialPosts?: Maybe<Scalars["Boolean"]["output"]>;
    includeVideo?: Maybe<Scalars["Boolean"]["output"]>;
};

export type CampaignOutcomeInput = {
    fbMentions?: InputMaybe<Array<Scalars["String"]["input"]>>;
    hashtags?: InputMaybe<Array<Scalars["String"]["input"]>>;
    igMentions?: InputMaybe<Array<Scalars["String"]["input"]>>;
    includeImages?: InputMaybe<Scalars["Boolean"]["input"]>;
    includeSocialPosts?: InputMaybe<Scalars["Boolean"]["input"]>;
    includeVideo?: InputMaybe<Scalars["Boolean"]["input"]>;
};

export type CampaignPricing = {
    __typename?: "CampaignPricing";
    discountCodes?: Maybe<CampaignDiscountCodeItems>;
    discountPercent?: Maybe<Scalars["Float"]["output"]>;
    isFree?: Maybe<Scalars["Boolean"]["output"]>;
};

export type CampaignProductResults = {
    __typename?: "CampaignProductResults";
    approvedCount?: Maybe<Scalars["Int"]["output"]>;
    attributeRatings?: Maybe<Array<ProductAttributeRating>>;
    censuredCount?: Maybe<Scalars["Int"]["output"]>;
    productId?: Maybe<Scalars["String"]["output"]>;
    rejectedCount?: Maybe<Scalars["Int"]["output"]>;
    totalRating?: Maybe<Scalars["Float"]["output"]>;
    totalRatingBreakup?: Maybe<Array<RatingBreakupItem>>;
    wouldRecommendCount?: Maybe<Scalars["Int"]["output"]>;
    wouldRecommendPercent?: Maybe<Scalars["Float"]["output"]>;
};

export type CampaignRestrictions = {
    __typename?: "CampaignRestrictions";
    ageMax?: Maybe<Scalars["Int"]["output"]>;
    ageMin?: Maybe<Scalars["Int"]["output"]>;
    gender?: Maybe<Gender>;
    location?: Maybe<Address>;
};

export type CampaignRestrictionsInput = {
    ageMax?: InputMaybe<Scalars["Int"]["input"]>;
    ageMin?: InputMaybe<Scalars["Int"]["input"]>;
    gender?: InputMaybe<Gender>;
    location?: InputMaybe<AddressInput>;
};

export type CampaignResults = {
    __typename?: "CampaignResults";
    products?: Maybe<Array<CampaignProductResults>>;
};

export type CampaignSettings = {
    __typename?: "CampaignSettings";
    capacity?: Maybe<Scalars["Int"]["output"]>;
    closeAt?: Maybe<Scalars["Float"]["output"]>;
    openAt?: Maybe<Scalars["Float"]["output"]>;
    registrationPeriodDays?: Maybe<Scalars["Int"]["output"]>;
    submissionPeriodDays?: Maybe<Scalars["Int"]["output"]>;
};

export type CampaignSettingsInput = {
    capacity?: InputMaybe<Scalars["Int"]["input"]>;
    closeAt?: InputMaybe<Scalars["Float"]["input"]>;
    openAt?: InputMaybe<Scalars["Float"]["input"]>;
    registrationPeriodDays?: InputMaybe<Scalars["Int"]["input"]>;
    submissionPeriodDays?: InputMaybe<Scalars["Int"]["input"]>;
};

export const CampaignState = {
    Approved: "approved",
    Closed: "closed",
    Draft: "draft",
    Finished: "finished",
    Opened: "opened",
    Publishable: "publishable",
    Published: "published",
} as const;

export type CampaignState = (typeof CampaignState)[keyof typeof CampaignState];
export type CampaignTag = {
    __typename?: "CampaignTag";
    color?: Maybe<Scalars["String"]["output"]>;
    key?: Maybe<Scalars["String"]["output"]>;
    text?: Maybe<Scalars["String"]["output"]>;
};

export type CampaignTagInput = {
    color?: InputMaybe<Scalars["String"]["input"]>;
    key?: InputMaybe<Scalars["String"]["input"]>;
    text?: InputMaybe<Scalars["String"]["input"]>;
};

export type CampaignTimelineSettingsInput = {
    closeAt?: InputMaybe<Scalars["Float"]["input"]>;
    openAt?: InputMaybe<Scalars["Float"]["input"]>;
    registrationPeriodDays?: InputMaybe<Scalars["Int"]["input"]>;
    submissionPeriodDays?: InputMaybe<Scalars["Int"]["input"]>;
};

export type CampaignUpdate = {
    __typename?: "CampaignUpdate";
    campaignId?: Maybe<Scalars["String"]["output"]>;
    reason?: Maybe<Scalars["String"]["output"]>;
};

export type Client = {
    __typename?: "Client";
    api?: Maybe<Api>;
    billing?: Maybe<ClientBilling>;
    credits?: Maybe<ClientCredits>;
    id?: Maybe<Scalars["String"]["output"]>;
    invoices?: Maybe<InvoiceItems>;
    maxQuestionnaireQuestions: Scalars["Int"]["output"];
    name?: Maybe<Scalars["String"]["output"]>;
    role?: Maybe<ClientUserRole>;
    tenant?: Maybe<Tenant>;
    tenants?: Maybe<TenantItems>;
    users?: Maybe<ClientUserItems>;
};

export type ClientInvoicesArgs = {
    nextToken?: InputMaybe<Scalars["String"]["input"]>;
};

export type ClientTenantArgs = {
    tenantId?: InputMaybe<Scalars["String"]["input"]>;
};

export type ClientTenantsArgs = {
    nextToken?: InputMaybe<Scalars["String"]["input"]>;
};

export type ClientUsersArgs = {
    limit?: InputMaybe<Scalars["Int"]["input"]>;
    nextToken?: InputMaybe<Scalars["String"]["input"]>;
};

export type ClientBilling = {
    __typename?: "ClientBilling";
    address?: Maybe<Address>;
    cin?: Maybe<Scalars["String"]["output"]>;
    email?: Maybe<Scalars["String"]["output"]>;
    name?: Maybe<Scalars["String"]["output"]>;
    tin?: Maybe<Scalars["String"]["output"]>;
};

export type ClientBillingInput = {
    address?: InputMaybe<AddressInput>;
    cin?: InputMaybe<Scalars["String"]["input"]>;
    email?: InputMaybe<Scalars["String"]["input"]>;
    name?: InputMaybe<Scalars["String"]["input"]>;
    tin?: InputMaybe<Scalars["String"]["input"]>;
};

export type ClientCredits = {
    __typename?: "ClientCredits";
    availableBalanceCredits?: Maybe<Scalars["Int"]["output"]>;
};

export type ClientItems = {
    __typename?: "ClientItems";
    items?: Maybe<Array<Client>>;
    nextToken?: Maybe<Scalars["String"]["output"]>;
};

export type ClientSettingsInput = {
    name?: InputMaybe<Scalars["String"]["input"]>;
};

export type ClientUser = {
    __typename?: "ClientUser";
    email?: Maybe<Scalars["String"]["output"]>;
    firstName?: Maybe<Scalars["String"]["output"]>;
    id?: Maybe<Scalars["String"]["output"]>;
    lastName?: Maybe<Scalars["String"]["output"]>;
    locale?: Maybe<Scalars["String"]["output"]>;
    role?: Maybe<ClientUserRole>;
};

export type ClientUserInput = {
    email?: InputMaybe<Scalars["String"]["input"]>;
    firstName?: InputMaybe<Scalars["String"]["input"]>;
    lastName?: InputMaybe<Scalars["String"]["input"]>;
};

export type ClientUserItems = {
    __typename?: "ClientUserItems";
    items?: Maybe<Array<ClientUser>>;
    nextToken?: Maybe<Scalars["String"]["output"]>;
};

export const ClientUserRole = {
    Admin: "admin",
    Developer: "developer",
    Member: "member",
    Owner: "owner",
} as const;

export type ClientUserRole = (typeof ClientUserRole)[keyof typeof ClientUserRole];
export type CognitoUser = {
    __typename?: "CognitoUser";
    Attributes?: Maybe<Array<CognitoUserAttribute>>;
    Enabled?: Maybe<Scalars["Boolean"]["output"]>;
    Sub?: Maybe<Scalars["String"]["output"]>;
    UserCreateDate?: Maybe<Scalars["Float"]["output"]>;
    UserLastModifiedDate?: Maybe<Scalars["Float"]["output"]>;
    UserStatus?: Maybe<Scalars["String"]["output"]>;
    Username?: Maybe<Scalars["String"]["output"]>;
};

export type CognitoUserAttribute = {
    __typename?: "CognitoUserAttribute";
    Name?: Maybe<Scalars["String"]["output"]>;
    Value?: Maybe<Scalars["String"]["output"]>;
};

export type CognitoUserItems = {
    __typename?: "CognitoUserItems";
    items?: Maybe<Array<CognitoUser>>;
    nextToken?: Maybe<Scalars["String"]["output"]>;
};

export type CreateCampaignInput = {
    clientId?: InputMaybe<Scalars["String"]["input"]>;
    delivery?: InputMaybe<CampaignDeliveryInput>;
    description?: InputMaybe<RichTextInput>;
    displayTenantIds?: InputMaybe<Array<Scalars["String"]["input"]>>;
    id?: InputMaybe<Scalars["String"]["input"]>;
    images?: InputMaybe<Array<CampaignImageInput>>;
    mainTenantId: Scalars["String"]["input"];
    name?: InputMaybe<Scalars["String"]["input"]>;
    outcome?: InputMaybe<CampaignOutcomeInput>;
    pricing?: InputMaybe<CreateCampaignPricingInput>;
    productIds: Array<Scalars["String"]["input"]>;
    productReviewDestinations?: InputMaybe<Array<ProductReviewDestinationInput>>;
    questionnaire?: InputMaybe<QuestionnaireInput>;
    restrictions?: InputMaybe<CampaignRestrictionsInput>;
    settings?: InputMaybe<CampaignSettingsInput>;
    slug?: InputMaybe<Scalars["String"]["input"]>;
    tags?: InputMaybe<Array<CampaignTagInput>>;
    tenantId: Scalars["String"]["input"];
};

export type CreateCampaignInquiryInput = {
    additionalNotes?: InputMaybe<Scalars["String"]["input"]>;
    clientId: Scalars["String"]["input"];
    delivery?: InputMaybe<CampaignDeliveryInput>;
    description?: InputMaybe<RichTextInput>;
    displayTenantIds?: InputMaybe<Array<Scalars["String"]["input"]>>;
    images?: InputMaybe<Array<CampaignImageInput>>;
    mainTenantId: Scalars["String"]["input"];
    name: Scalars["String"]["input"];
    outcome?: InputMaybe<CampaignOutcomeInput>;
    pricing?: InputMaybe<CreateCampaignPricingInput>;
    products?: InputMaybe<Array<CampaignInquiryProductInput>>;
    questionnaire?: InputMaybe<QuestionnaireInput>;
    restrictions?: InputMaybe<CampaignRestrictionsInput>;
    settings?: InputMaybe<CampaignInquirySettingsInput>;
    tags?: InputMaybe<Array<CampaignTagInput>>;
    tenantId: Scalars["String"]["input"];
    thumbnailImage?: InputMaybe<FileInput>;
};

export type CreateCampaignPricingInput = {
    discountCodes?: InputMaybe<Array<Scalars["String"]["input"]>>;
    discountPercent?: InputMaybe<Scalars["Float"]["input"]>;
    isFree?: InputMaybe<Scalars["Boolean"]["input"]>;
};

export type CreateProductInput = {
    attributes?: InputMaybe<Array<ProductAttributeInput>>;
    category: ProductCategoryInput;
    description?: InputMaybe<RichTextInput>;
    detailPageLinks?: InputMaybe<Array<ProductLinkInput>>;
    ean?: InputMaybe<Scalars["String"]["input"]>;
    id?: InputMaybe<Scalars["String"]["input"]>;
    images?: InputMaybe<Array<FileInput>>;
    info?: InputMaybe<ProductInfoInput>;
    name: Scalars["String"]["input"];
    reviewFocusInstructions?: InputMaybe<RichTextInput>;
    slug: Scalars["String"]["input"];
    urlAddress?: InputMaybe<Scalars["String"]["input"]>;
    userManualLink?: InputMaybe<Scalars["String"]["input"]>;
};

export type CreditCurrencyConversionRate = {
    __typename?: "CreditCurrencyConversionRate";
    amountPerCredit?: Maybe<Scalars["Float"]["output"]>;
    currency?: Maybe<Scalars["String"]["output"]>;
};

export type CreditCurrencyConversionRates = {
    __typename?: "CreditCurrencyConversionRates";
    rates?: Maybe<Array<CreditCurrencyConversionRate>>;
};

export type EmailTemplate = {
    __typename?: "EmailTemplate";
    content?: Maybe<EmailTemplateContent>;
    from?: Maybe<Scalars["String"]["output"]>;
    name?: Maybe<Scalars["String"]["output"]>;
    subject?: Maybe<Scalars["String"]["output"]>;
    updatedAt?: Maybe<Scalars["Float"]["output"]>;
};

export type EmailTemplateContent = {
    __typename?: "EmailTemplateContent";
    html?: Maybe<Scalars["String"]["output"]>;
    json?: Maybe<Scalars["String"]["output"]>;
    text?: Maybe<Scalars["String"]["output"]>;
};

export type EmailTemplateContentInput = {
    html?: InputMaybe<Scalars["String"]["input"]>;
    json?: InputMaybe<Scalars["String"]["input"]>;
    text?: InputMaybe<Scalars["String"]["input"]>;
};

export type EmailTemplateInput = {
    content?: InputMaybe<EmailTemplateContentInput>;
    from?: InputMaybe<Scalars["String"]["input"]>;
    name?: InputMaybe<Scalars["String"]["input"]>;
    subject?: InputMaybe<Scalars["String"]["input"]>;
};

export type EmailTemplateItems = {
    __typename?: "EmailTemplateItems";
    items?: Maybe<Array<EmailTemplate>>;
    nextToken?: Maybe<Scalars["String"]["output"]>;
};

export type ExportCampaignResultsParamsInput = {
    includeImages?: InputMaybe<Scalars["Boolean"]["input"]>;
    includeStamps?: InputMaybe<Scalars["Boolean"]["input"]>;
    includeVideos?: InputMaybe<Scalars["Boolean"]["input"]>;
};

export type ExportJob = {
    __typename?: "ExportJob";
    downloadUrl?: Maybe<Scalars["String"]["output"]>;
    errorJson?: Maybe<Scalars["String"]["output"]>;
    finishedAt?: Maybe<Scalars["Float"]["output"]>;
    id?: Maybe<Scalars["String"]["output"]>;
    objectKey?: Maybe<Scalars["String"]["output"]>;
    paramsJson?: Maybe<Scalars["String"]["output"]>;
    startedAt?: Maybe<Scalars["Float"]["output"]>;
    state?: Maybe<Scalars["String"]["output"]>;
    stats?: Maybe<ExportJobStats>;
};

export type ExportJobInput = {
    downloadUrl?: InputMaybe<Scalars["String"]["input"]>;
    errorJson?: InputMaybe<Scalars["String"]["input"]>;
    finishedAt?: InputMaybe<Scalars["Float"]["input"]>;
    id?: InputMaybe<Scalars["String"]["input"]>;
    objectKey?: InputMaybe<Scalars["String"]["input"]>;
    paramsJson?: InputMaybe<Scalars["String"]["input"]>;
    startedAt?: InputMaybe<Scalars["Float"]["input"]>;
    state?: InputMaybe<Scalars["String"]["input"]>;
    stats?: InputMaybe<ExportJobStatsInput>;
};

export type ExportJobStats = {
    __typename?: "ExportJobStats";
    compressedBytes?: Maybe<Scalars["Int"]["output"]>;
    originalBytes?: Maybe<Scalars["Int"]["output"]>;
};

export type ExportJobStatsInput = {
    compressedBytes?: InputMaybe<Scalars["Int"]["input"]>;
    originalBytes?: InputMaybe<Scalars["Int"]["input"]>;
};

export type ExportJobUpdate = {
    __typename?: "ExportJobUpdate";
    job?: Maybe<ExportJob>;
    jobId?: Maybe<Scalars["String"]["output"]>;
};

export type File = {
    __typename?: "File";
    id?: Maybe<Scalars["String"]["output"]>;
    objectKey?: Maybe<Scalars["String"]["output"]>;
    presignedUploadUrl?: Maybe<Scalars["String"]["output"]>;
    src?: Maybe<Scalars["String"]["output"]>;
    uploadedAt?: Maybe<Scalars["Float"]["output"]>;
    uploadedBy?: Maybe<User>;
};

export type FileInput = {
    id?: InputMaybe<Scalars["String"]["input"]>;
    objectKey?: InputMaybe<Scalars["String"]["input"]>;
    src?: InputMaybe<Scalars["String"]["input"]>;
};

export const Gender = {
    Female: "female",
    Male: "male",
    Other: "other",
} as const;

export type Gender = (typeof Gender)[keyof typeof Gender];
export type Invoice = {
    __typename?: "Invoice";
    createdAt?: Maybe<Scalars["Float"]["output"]>;
    id?: Maybe<Scalars["String"]["output"]>;
    stripeInvoice?: Maybe<StripeInvoice>;
    stripeInvoiceItems?: Maybe<Array<StripeInvoiceItem>>;
    type?: Maybe<Scalars["String"]["output"]>;
};

export type InvoiceItems = {
    __typename?: "InvoiceItems";
    items?: Maybe<Array<Invoice>>;
    nextToken?: Maybe<Scalars["String"]["output"]>;
};

export type Manufacturer = {
    __typename?: "Manufacturer";
    id?: Maybe<Scalars["String"]["output"]>;
    logo?: Maybe<File>;
    name?: Maybe<Scalars["String"]["output"]>;
};

export type ManufacturerInput = {
    id?: InputMaybe<Scalars["String"]["input"]>;
    logo?: InputMaybe<FileInput>;
    name: Scalars["String"]["input"];
};

export type ManufacturerItems = {
    __typename?: "ManufacturerItems";
    items?: Maybe<Array<Manufacturer>>;
    nextToken?: Maybe<Scalars["String"]["output"]>;
};

export type Mutation = {
    __typename?: "Mutation";
    approveCampaign?: Maybe<Campaign>;
    approveReview?: Maybe<Review>;
    attachTenantLogo?: Maybe<Tenant>;
    chargeCredits?: Maybe<Scalars["String"]["output"]>;
    createAPIKey?: Maybe<ApiKey>;
    createCampaignInquiry?: Maybe<CampaignInquiry>;
    deleteAPIKey?: Maybe<ApiKey>;
    downloadExportJob?: Maybe<Scalars["String"]["output"]>;
    duplicateImage?: Maybe<File>;
    exportCampaignResults?: Maybe<Scalars["String"]["output"]>;
    inviteClientUser?: Maybe<ClientUser>;
    issueChargeCreditsInvoice?: Maybe<Invoice>;
    pushCampaignUpdate?: Maybe<CampaignUpdate>;
    pushExportJobUpdate?: Maybe<ExportJobUpdate>;
    requestTenantCreation?: Maybe<Scalars["String"]["output"]>;
    resetPassword?: Maybe<Scalars["String"]["output"]>;
    sendReviewComment?: Maybe<Review>;
    updateClientBilling?: Maybe<Client>;
    updateClientSettings?: Maybe<Client>;
    updateTenantName?: Maybe<Tenant>;
    updateTenantSEO?: Maybe<Tenant>;
    uploadImage?: Maybe<File>;
};

export type MutationApproveCampaignArgs = {
    campaignId: Scalars["String"]["input"];
};

export type MutationApproveReviewArgs = {
    clientId: Scalars["String"]["input"];
    reviewId: Scalars["String"]["input"];
};

export type MutationAttachTenantLogoArgs = {
    clientId: Scalars["String"]["input"];
    imageId: Scalars["String"]["input"];
    tenantId: Scalars["String"]["input"];
};

export type MutationChargeCreditsArgs = {
    amountCredits: Scalars["Int"]["input"];
    clientId: Scalars["String"]["input"];
    currency: Scalars["String"]["input"];
};

export type MutationCreateApiKeyArgs = {
    clientId: Scalars["String"]["input"];
    expiresAt?: InputMaybe<Scalars["Float"]["input"]>;
    name: Scalars["String"]["input"];
};

export type MutationCreateCampaignInquiryArgs = {
    campaignInquiry: CreateCampaignInquiryInput;
};

export type MutationDeleteApiKeyArgs = {
    apiKeyId: Scalars["String"]["input"];
    clientId: Scalars["String"]["input"];
};

export type MutationDownloadExportJobArgs = {
    jobId: Scalars["String"]["input"];
};

export type MutationDuplicateImageArgs = {
    id: Scalars["String"]["input"];
};

export type MutationExportCampaignResultsArgs = {
    campaignId: Scalars["String"]["input"];
    clientId: Scalars["String"]["input"];
    params: ExportCampaignResultsParamsInput;
};

export type MutationInviteClientUserArgs = {
    clientId: Scalars["String"]["input"];
    clientUser: ClientUserInput;
    clientUserLocale?: InputMaybe<Scalars["String"]["input"]>;
    clientUserRole: ClientUserRole;
};

export type MutationIssueChargeCreditsInvoiceArgs = {
    amountCredits: Scalars["Int"]["input"];
    clientId: Scalars["String"]["input"];
    currency: Scalars["String"]["input"];
};

export type MutationPushCampaignUpdateArgs = {
    campaignId: Scalars["String"]["input"];
    reason?: InputMaybe<Scalars["String"]["input"]>;
};

export type MutationPushExportJobUpdateArgs = {
    job: ExportJobInput;
    jobId: Scalars["String"]["input"];
};

export type MutationRequestTenantCreationArgs = {
    clientId: Scalars["String"]["input"];
    message?: InputMaybe<Scalars["String"]["input"]>;
};

export type MutationResetPasswordArgs = {
    email: Scalars["String"]["input"];
};

export type MutationSendReviewCommentArgs = {
    clientId: Scalars["String"]["input"];
    content: Scalars["String"]["input"];
    reviewId: Scalars["String"]["input"];
};

export type MutationUpdateClientBillingArgs = {
    billing: ClientBillingInput;
    clientId: Scalars["String"]["input"];
};

export type MutationUpdateClientSettingsArgs = {
    clientId: Scalars["String"]["input"];
    settings: ClientSettingsInput;
};

export type MutationUpdateTenantNameArgs = {
    clientId: Scalars["String"]["input"];
    name: Scalars["String"]["input"];
    tenantId: Scalars["String"]["input"];
};

export type MutationUpdateTenantSeoArgs = {
    clientId: Scalars["String"]["input"];
    seo: TenantSeoConfigInput;
    tenantId: Scalars["String"]["input"];
};

export type MutationUploadImageArgs = {
    filename: Scalars["String"]["input"];
};

export type PaginationInput = {
    limit?: InputMaybe<Scalars["Int"]["input"]>;
    offset?: InputMaybe<Scalars["Int"]["input"]>;
};

export type Product = {
    __typename?: "Product";
    attributes?: Maybe<Array<ProductAttribute>>;
    campaignIds?: Maybe<Array<Scalars["String"]["output"]>>;
    category?: Maybe<ProductCategory>;
    codes?: Maybe<ProductCodes>;
    description?: Maybe<RichText>;
    detailPageLinks?: Maybe<Array<ProductLink>>;
    fallbackLocale?: Maybe<Scalars["String"]["output"]>;
    id?: Maybe<Scalars["String"]["output"]>;
    image?: Maybe<File>;
    images?: Maybe<Array<File>>;
    info?: Maybe<ProductInfo>;
    isLocalized?: Maybe<Scalars["Boolean"]["output"]>;
    locale?: Maybe<Scalars["String"]["output"]>;
    locales?: Maybe<Array<Scalars["String"]["output"]>>;
    name?: Maybe<Scalars["String"]["output"]>;
    previousSlugs?: Maybe<Array<Scalars["String"]["output"]>>;
    rating?: Maybe<ProductRating>;
    reviewFocusInstructions?: Maybe<RichText>;
    slug?: Maybe<Scalars["String"]["output"]>;
    stampedImages?: Maybe<Array<StampedProductImage>>;
    thumbnailImage?: Maybe<File>;
    urlAddress?: Maybe<Scalars["String"]["output"]>;
    userManualLink?: Maybe<Scalars["String"]["output"]>;
};

export type ProductAttribute = {
    __typename?: "ProductAttribute";
    fallbackLocale?: Maybe<Scalars["String"]["output"]>;
    id?: Maybe<Scalars["String"]["output"]>;
    locale?: Maybe<Scalars["String"]["output"]>;
    locales?: Maybe<Array<Scalars["String"]["output"]>>;
    name?: Maybe<Scalars["String"]["output"]>;
    nameLocales?: Maybe<Array<ProductAttributeNameLocale>>;
};

export type ProductAttributeInput = {
    id: Scalars["String"]["input"];
    locale?: InputMaybe<Scalars["String"]["input"]>;
    name?: InputMaybe<Scalars["String"]["input"]>;
};

export type ProductAttributeItems = {
    __typename?: "ProductAttributeItems";
    items?: Maybe<Array<ProductAttribute>>;
    nextToken?: Maybe<Scalars["String"]["output"]>;
};

export type ProductAttributeLocaleInput = {
    locale: Scalars["String"]["input"];
    name: Scalars["String"]["input"];
};

export type ProductAttributeNameLocale = {
    __typename?: "ProductAttributeNameLocale";
    locale?: Maybe<Scalars["String"]["output"]>;
    name?: Maybe<Scalars["String"]["output"]>;
};

export type ProductAttributeRating = {
    __typename?: "ProductAttributeRating";
    id?: Maybe<Scalars["String"]["output"]>;
    name?: Maybe<Scalars["String"]["output"]>;
    rating?: Maybe<Scalars["Float"]["output"]>;
};

export type ProductCategory = {
    __typename?: "ProductCategory";
    key?: Maybe<Scalars["String"]["output"]>;
    parent?: Maybe<ProductCategory>;
};

export type ProductCategoryInput = {
    key: Scalars["String"]["input"];
    parent?: InputMaybe<ProductCategoryInput>;
};

export type ProductCategoryItems = {
    __typename?: "ProductCategoryItems";
    items?: Maybe<Array<ProductCategory>>;
    nextToken?: Maybe<Scalars["String"]["output"]>;
};

export type ProductCodes = {
    __typename?: "ProductCodes";
    ean?: Maybe<Scalars["String"]["output"]>;
};

export type ProductInfo = {
    __typename?: "ProductInfo";
    manufacturer?: Maybe<Manufacturer>;
    model?: Maybe<Scalars["String"]["output"]>;
};

export type ProductInfoInput = {
    manufacturerId?: InputMaybe<Scalars["String"]["input"]>;
    model?: InputMaybe<Scalars["String"]["input"]>;
};

export type ProductItems = {
    __typename?: "ProductItems";
    items?: Maybe<Array<Product>>;
    nextToken?: Maybe<Scalars["String"]["output"]>;
};

export type ProductLink = {
    __typename?: "ProductLink";
    label?: Maybe<Scalars["String"]["output"]>;
    src?: Maybe<Scalars["String"]["output"]>;
};

export type ProductLinkInput = {
    label?: InputMaybe<Scalars["String"]["input"]>;
    src?: InputMaybe<Scalars["String"]["input"]>;
};

export type ProductRating = {
    __typename?: "ProductRating";
    approvedCount?: Maybe<Scalars["Int"]["output"]>;
    attributeRatings?: Maybe<Array<ProductAttributeRating>>;
    censuredCount?: Maybe<Scalars["Int"]["output"]>;
    rejectedCount?: Maybe<Scalars["Int"]["output"]>;
    totalRating?: Maybe<Scalars["Float"]["output"]>;
    totalRatingBreakup?: Maybe<Array<RatingBreakupItem>>;
    wouldRecommendCount?: Maybe<Scalars["Int"]["output"]>;
    wouldRecommendPercent?: Maybe<Scalars["Float"]["output"]>;
};

export type ProductReviewDestination = {
    __typename?: "ProductReviewDestination";
    destinations?: Maybe<Array<ReviewDestination>>;
    productId?: Maybe<Scalars["String"]["output"]>;
};

export type ProductReviewDestinationInput = {
    destinations?: InputMaybe<Array<ReviewDestinationInput>>;
    productId?: InputMaybe<Scalars["String"]["input"]>;
};

export type ProductsByCode = {
    __typename?: "ProductsByCode";
    ean?: Maybe<Array<Product>>;
};

export type Query = {
    __typename?: "Query";
    campaign?: Maybe<Campaign>;
    campaignInquiries?: Maybe<CampaignInquiryItems>;
    campaignInquiry?: Maybe<CampaignInquiry>;
    campaigns?: Maybe<CampaignItems>;
    client?: Maybe<Client>;
    clients?: Maybe<ClientItems>;
    currentUser?: Maybe<ClientUser>;
    manufacturer?: Maybe<Manufacturer>;
    manufacturers?: Maybe<ManufacturerItems>;
    product?: Maybe<Product>;
    productAttribute?: Maybe<ProductAttribute>;
    productAttributes?: Maybe<ProductAttributeItems>;
    productByEAN?: Maybe<Product>;
    productCategories?: Maybe<ProductCategoryItems>;
    products?: Maybe<ProductItems>;
    productsByCode?: Maybe<ProductsByCode>;
    review?: Maybe<Review>;
    system?: Maybe<System>;
    tenant?: Maybe<Tenant>;
    tenants?: Maybe<TenantItems>;
};

export type QueryCampaignArgs = {
    campaignId: Scalars["String"]["input"];
};

export type QueryCampaignInquiriesArgs = {
    client: Scalars["String"]["input"];
    limit?: InputMaybe<Scalars["Int"]["input"]>;
    nextToken?: InputMaybe<Scalars["String"]["input"]>;
    resolved?: InputMaybe<Scalars["Boolean"]["input"]>;
};

export type QueryCampaignInquiryArgs = {
    campaignInquiryId: Scalars["String"]["input"];
};

export type QueryCampaignsArgs = {
    client: Scalars["String"]["input"];
    limit?: InputMaybe<Scalars["Int"]["input"]>;
    nextToken?: InputMaybe<Scalars["String"]["input"]>;
    state?: InputMaybe<CampaignState>;
};

export type QueryClientArgs = {
    clientId: Scalars["String"]["input"];
};

export type QueryManufacturerArgs = {
    manufacturerId?: InputMaybe<Scalars["String"]["input"]>;
};

export type QueryManufacturersArgs = {
    limit?: InputMaybe<Scalars["Int"]["input"]>;
    nextToken?: InputMaybe<Scalars["String"]["input"]>;
};

export type QueryProductArgs = {
    locale?: InputMaybe<Scalars["String"]["input"]>;
    productId: Scalars["String"]["input"];
};

export type QueryProductAttributeArgs = {
    locale?: InputMaybe<Scalars["String"]["input"]>;
    productAttributeId: Scalars["String"]["input"];
};

export type QueryProductAttributesArgs = {
    limit?: InputMaybe<Scalars["Int"]["input"]>;
    locale?: InputMaybe<Scalars["String"]["input"]>;
    nextToken?: InputMaybe<Scalars["String"]["input"]>;
};

export type QueryProductByEanArgs = {
    ean: Scalars["String"]["input"];
    excludeProductId?: InputMaybe<Scalars["String"]["input"]>;
    locale?: InputMaybe<Scalars["String"]["input"]>;
};

export type QueryProductCategoriesArgs = {
    limit?: InputMaybe<Scalars["Int"]["input"]>;
    nextToken?: InputMaybe<Scalars["String"]["input"]>;
};

export type QueryProductsArgs = {
    category?: InputMaybe<Array<Scalars["String"]["input"]>>;
    limit?: InputMaybe<Scalars["Int"]["input"]>;
    locale?: InputMaybe<Scalars["String"]["input"]>;
    nextToken?: InputMaybe<Scalars["String"]["input"]>;
};

export type QueryProductsByCodeArgs = {
    code: Scalars["String"]["input"];
};

export type QueryReviewArgs = {
    clientId: Scalars["String"]["input"];
    reviewId: Scalars["String"]["input"];
};

export type QueryTenantArgs = {
    tenantId: Scalars["String"]["input"];
};

export type QueryTenantsArgs = {
    limit?: InputMaybe<Scalars["Int"]["input"]>;
    locale?: InputMaybe<Array<Scalars["String"]["input"]>>;
    nextToken?: InputMaybe<Scalars["String"]["input"]>;
    tenant?: InputMaybe<Array<Scalars["String"]["input"]>>;
    type?: InputMaybe<Array<TenantType>>;
};

export type Question = {
    __typename?: "Question";
    condition?: Maybe<QuestionCondition>;
    isOptional?: Maybe<Scalars["Boolean"]["output"]>;
    key?: Maybe<Scalars["String"]["output"]>;
    options?: Maybe<Array<Maybe<QuestionOption>>>;
    text?: Maybe<Scalars["String"]["output"]>;
    type?: Maybe<QuestionType>;
};

export type QuestionCondition = {
    __typename?: "QuestionCondition";
    dependsOn?: Maybe<Scalars["String"]["output"]>;
    requiredValue?: Maybe<Scalars["String"]["output"]>;
    type?: Maybe<QuestionConditionType>;
};

export type QuestionConditionInput = {
    dependsOn?: InputMaybe<Scalars["String"]["input"]>;
    requiredValue?: InputMaybe<Scalars["String"]["input"]>;
    type?: InputMaybe<QuestionConditionType>;
};

export const QuestionConditionType = {
    Eq: "eq",
    Gte: "gte",
    Lte: "lte",
    None: "none",
    Oneof: "oneof",
} as const;

export type QuestionConditionType = (typeof QuestionConditionType)[keyof typeof QuestionConditionType];
export type QuestionCriteria = {
    __typename?: "QuestionCriteria";
    dependsOn?: Maybe<Scalars["String"]["output"]>;
    note?: Maybe<Scalars["String"]["output"]>;
    requiredValue?: Maybe<Scalars["String"]["output"]>;
    type?: Maybe<QuestionConditionType>;
};

export type QuestionCriteriaInput = {
    dependsOn?: InputMaybe<Scalars["String"]["input"]>;
    note?: InputMaybe<Scalars["String"]["input"]>;
    requiredValue?: InputMaybe<Scalars["String"]["input"]>;
    type?: InputMaybe<QuestionConditionType>;
};

export type QuestionInput = {
    condition?: InputMaybe<QuestionConditionInput>;
    isOptional?: InputMaybe<Scalars["Boolean"]["input"]>;
    key?: InputMaybe<Scalars["String"]["input"]>;
    options?: InputMaybe<Array<InputMaybe<QuestionOptionInput>>>;
    text?: InputMaybe<Scalars["String"]["input"]>;
    type?: InputMaybe<QuestionType>;
};

export type QuestionOption = {
    __typename?: "QuestionOption";
    key?: Maybe<Scalars["String"]["output"]>;
    text?: Maybe<Scalars["String"]["output"]>;
};

export type QuestionOptionInput = {
    key?: InputMaybe<Scalars["String"]["input"]>;
    text?: InputMaybe<Scalars["String"]["input"]>;
};

export const QuestionType = {
    AddressFull: "addressFull",
    BirthDate: "birthDate",
    Checkbox: "checkbox",
    Country: "country",
    Date: "date",
    DateTime: "dateTime",
    Number: "number",
    Radio: "radio",
    Text: "text",
    Textarea: "textarea",
    Time: "time",
} as const;

export type QuestionType = (typeof QuestionType)[keyof typeof QuestionType];
export type Questionnaire = {
    __typename?: "Questionnaire";
    criteria?: Maybe<Array<Maybe<QuestionCriteria>>>;
    id?: Maybe<Scalars["String"]["output"]>;
    questions?: Maybe<Array<Maybe<Question>>>;
};

export type QuestionnaireInput = {
    criteria?: InputMaybe<Array<InputMaybe<QuestionCriteriaInput>>>;
    id?: InputMaybe<Scalars["String"]["input"]>;
    questions?: InputMaybe<Array<InputMaybe<QuestionInput>>>;
};

export type QuestionnaireResponse = {
    __typename?: "QuestionnaireResponse";
    answers?: Maybe<Array<QuestionnaireResponseAnswer>>;
    questionnaire?: Maybe<Questionnaire>;
};

export type QuestionnaireResponseAnswer = {
    __typename?: "QuestionnaireResponseAnswer";
    key?: Maybe<Scalars["String"]["output"]>;
    value?: Maybe<Scalars["String"]["output"]>;
};

export type RatingBreakupItem = {
    __typename?: "RatingBreakupItem";
    count?: Maybe<Scalars["Int"]["output"]>;
    rating?: Maybe<Scalars["Float"]["output"]>;
};

export type Review = {
    __typename?: "Review";
    attributeRatings?: Maybe<Array<ProductAttributeRating>>;
    campaign?: Maybe<Campaign>;
    censureMessage?: Maybe<Scalars["String"]["output"]>;
    comments?: Maybe<ReviewCommentItems>;
    commentsCount?: Maybe<Scalars["Int"]["output"]>;
    cons?: Maybe<Array<Scalars["String"]["output"]>>;
    contents?: Maybe<Array<ReviewContent>>;
    id?: Maybe<Scalars["String"]["output"]>;
    images?: Maybe<Array<File>>;
    imagesCount?: Maybe<Scalars["Int"]["output"]>;
    isAwaitingClientApproval?: Maybe<Scalars["Boolean"]["output"]>;
    lang?: Maybe<Scalars["String"]["output"]>;
    product?: Maybe<Product>;
    pros?: Maybe<Array<Scalars["String"]["output"]>>;
    rejectionMessage?: Maybe<Scalars["String"]["output"]>;
    reviewer?: Maybe<Reviewer>;
    state?: Maybe<ReviewState>;
    submittedContents?: Maybe<Array<Scalars["String"]["output"]>>;
    totalRating?: Maybe<Scalars["Float"]["output"]>;
    videos?: Maybe<Array<File>>;
    videosCount?: Maybe<Scalars["Int"]["output"]>;
    wouldRecommend?: Maybe<Scalars["Boolean"]["output"]>;
    wouldRecommendPercent?: Maybe<Scalars["Float"]["output"]>;
};

export type ReviewComment = {
    __typename?: "ReviewComment";
    author?: Maybe<User>;
    content?: Maybe<Scalars["String"]["output"]>;
    sentAt?: Maybe<Scalars["Float"]["output"]>;
};

export type ReviewCommentItems = {
    __typename?: "ReviewCommentItems";
    items?: Maybe<Array<ReviewComment>>;
    nextToken?: Maybe<Scalars["String"]["output"]>;
};

export type ReviewContent = {
    __typename?: "ReviewContent";
    content?: Maybe<Scalars["String"]["output"]>;
    destination?: Maybe<ReviewDestination>;
};

export type ReviewDestination = {
    __typename?: "ReviewDestination";
    config?: Maybe<Scalars["String"]["output"]>;
    configFields?: Maybe<Array<ReviewDestinationConfigField>>;
    isOrderNumber?: Maybe<Scalars["Boolean"]["output"]>;
    key?: Maybe<Scalars["String"]["output"]>;
    name?: Maybe<Scalars["String"]["output"]>;
    type?: Maybe<Scalars["String"]["output"]>;
};

export type ReviewDestinationConfigField = {
    __typename?: "ReviewDestinationConfigField";
    isRequiredForApproval?: Maybe<Scalars["Boolean"]["output"]>;
    label?: Maybe<Scalars["String"]["output"]>;
    path?: Maybe<Scalars["String"]["output"]>;
    placeholder?: Maybe<Scalars["String"]["output"]>;
    type?: Maybe<ReviewDestinationConfigFieldType>;
    urlStripQueryString?: Maybe<Scalars["Boolean"]["output"]>;
};

export type ReviewDestinationConfigFieldInput = {
    isRequiredForApproval?: InputMaybe<Scalars["Boolean"]["input"]>;
    label: Scalars["String"]["input"];
    path: Scalars["String"]["input"];
    placeholder?: InputMaybe<Scalars["String"]["input"]>;
    type: ReviewDestinationConfigFieldType;
    urlStripQueryString?: InputMaybe<Scalars["Boolean"]["input"]>;
};

export const ReviewDestinationConfigFieldType = {
    Text: "text",
    Url: "url",
} as const;

export type ReviewDestinationConfigFieldType =
    (typeof ReviewDestinationConfigFieldType)[keyof typeof ReviewDestinationConfigFieldType];
export type ReviewDestinationInput = {
    config?: InputMaybe<Scalars["String"]["input"]>;
    configFields?: InputMaybe<Array<ReviewDestinationConfigFieldInput>>;
    isOrderNumber?: InputMaybe<Scalars["Boolean"]["input"]>;
    key?: InputMaybe<Scalars["String"]["input"]>;
    name?: InputMaybe<Scalars["String"]["input"]>;
    type: Scalars["String"]["input"];
};

export type ReviewHistoryRecord = {
    __typename?: "ReviewHistoryRecord";
    action?: Maybe<Scalars["String"]["output"]>;
    message?: Maybe<Scalars["String"]["output"]>;
    performedAt?: Maybe<Scalars["Float"]["output"]>;
};

export type ReviewItems = {
    __typename?: "ReviewItems";
    items?: Maybe<Array<Review>>;
    nextToken?: Maybe<Scalars["String"]["output"]>;
};

export const ReviewState = {
    Approved: "approved",
    Censured: "censured",
    Draft: "draft",
    Rejected: "rejected",
    Submitted: "submitted",
} as const;

export type ReviewState = (typeof ReviewState)[keyof typeof ReviewState];
export type Reviewer = {
    __typename?: "Reviewer";
    blacklistHistory?: Maybe<Array<BlacklistHistoryRecord>>;
    blacklistedUntil?: Maybe<Scalars["Float"]["output"]>;
    campaignApplications?: Maybe<CampaignApplicationItems>;
    email?: Maybe<Scalars["String"]["output"]>;
    id?: Maybe<Scalars["String"]["output"]>;
    isBlacklisted?: Maybe<Scalars["Boolean"]["output"]>;
    note?: Maybe<ReviewerNote>;
    profile?: Maybe<ReviewerProfile>;
    profileImage?: Maybe<File>;
    socials?: Maybe<ReviewerSocials>;
};

export type ReviewerCampaignApplicationsArgs = {
    limit?: InputMaybe<Scalars["Int"]["input"]>;
    nextToken?: InputMaybe<Scalars["String"]["input"]>;
};

export type ReviewerItems = {
    __typename?: "ReviewerItems";
    items?: Maybe<Array<Reviewer>>;
    nextToken?: Maybe<Scalars["String"]["output"]>;
};

export type ReviewerNote = {
    __typename?: "ReviewerNote";
    content?: Maybe<Scalars["String"]["output"]>;
    updatedAt?: Maybe<Scalars["Float"]["output"]>;
    updatedBy?: Maybe<CognitoUser>;
};

export type ReviewerProfile = {
    __typename?: "ReviewerProfile";
    address?: Maybe<Address>;
    birthDate?: Maybe<Scalars["Float"]["output"]>;
    firstName?: Maybe<Scalars["String"]["output"]>;
    gender?: Maybe<Gender>;
    lastName?: Maybe<Scalars["String"]["output"]>;
    phoneNumber?: Maybe<Scalars["String"]["output"]>;
};

export type ReviewerSocials = {
    __typename?: "ReviewerSocials";
    fbFollowers?: Maybe<Scalars["Int"]["output"]>;
    fbUrl?: Maybe<Scalars["String"]["output"]>;
    hasFb?: Maybe<Scalars["Boolean"]["output"]>;
    hasIg?: Maybe<Scalars["Boolean"]["output"]>;
    igFollowers?: Maybe<Scalars["Int"]["output"]>;
    igUrl?: Maybe<Scalars["String"]["output"]>;
};

export type RichText = {
    __typename?: "RichText";
    images?: Maybe<Array<File>>;
    json?: Maybe<Scalars["String"]["output"]>;
};

export type RichTextInput = {
    images?: InputMaybe<Array<FileInput>>;
    json?: InputMaybe<Scalars["String"]["input"]>;
};

export type StampedProductImage = {
    __typename?: "StampedProductImage";
    image?: Maybe<File>;
    tenantId?: Maybe<Scalars["String"]["output"]>;
};

export type StripeInvoice = {
    __typename?: "StripeInvoice";
    amount_due?: Maybe<Scalars["Float"]["output"]>;
    amount_paid?: Maybe<Scalars["Float"]["output"]>;
    amount_remaining?: Maybe<Scalars["Float"]["output"]>;
    amount_shipping?: Maybe<Scalars["Float"]["output"]>;
    attempt_count?: Maybe<Scalars["Int"]["output"]>;
    attempted?: Maybe<Scalars["Boolean"]["output"]>;
    auto_advance?: Maybe<Scalars["Boolean"]["output"]>;
    billing_reason?: Maybe<Scalars["String"]["output"]>;
    collection_method?: Maybe<Scalars["String"]["output"]>;
    created?: Maybe<Scalars["Float"]["output"]>;
    currency?: Maybe<Scalars["String"]["output"]>;
    description?: Maybe<Scalars["String"]["output"]>;
    due_date?: Maybe<Scalars["Float"]["output"]>;
    effective_at?: Maybe<Scalars["Float"]["output"]>;
    ending_balance?: Maybe<Scalars["Int"]["output"]>;
    footer?: Maybe<Scalars["String"]["output"]>;
    hosted_invoice_url?: Maybe<Scalars["String"]["output"]>;
    id?: Maybe<Scalars["String"]["output"]>;
    invoice_pdf?: Maybe<Scalars["String"]["output"]>;
    number?: Maybe<Scalars["String"]["output"]>;
    paid?: Maybe<Scalars["Boolean"]["output"]>;
    period_end?: Maybe<Scalars["Float"]["output"]>;
    period_start?: Maybe<Scalars["Float"]["output"]>;
    status?: Maybe<Scalars["String"]["output"]>;
    subtotal?: Maybe<Scalars["Int"]["output"]>;
    subtotal_excluding_tax?: Maybe<Scalars["Int"]["output"]>;
    tax?: Maybe<Scalars["Int"]["output"]>;
    total?: Maybe<Scalars["Int"]["output"]>;
    total_excluding_tax?: Maybe<Scalars["Int"]["output"]>;
};

export type StripeInvoiceItem = {
    __typename?: "StripeInvoiceItem";
    amount?: Maybe<Scalars["Int"]["output"]>;
    amount_excluding_tax?: Maybe<Scalars["Int"]["output"]>;
    currency?: Maybe<Scalars["String"]["output"]>;
    description?: Maybe<Scalars["String"]["output"]>;
    id?: Maybe<Scalars["String"]["output"]>;
    type?: Maybe<Scalars["String"]["output"]>;
};

export type Subscription = {
    __typename?: "Subscription";
    onCampaignUpdate?: Maybe<CampaignUpdate>;
    onExportJobUpdate?: Maybe<ExportJobUpdate>;
};

export type SubscriptionOnCampaignUpdateArgs = {
    campaignId: Scalars["String"]["input"];
};

export type SubscriptionOnExportJobUpdateArgs = {
    jobId: Scalars["String"]["input"];
};

export type System = {
    __typename?: "System";
    creditCurrencyConversionRates?: Maybe<CreditCurrencyConversionRates>;
};

export type SystemCreditCurrencyConversionRatesArgs = {
    clientId: Scalars["String"]["input"];
};

export type Tenant = {
    __typename?: "Tenant";
    agreements?: Maybe<TenantAgreements>;
    campaignMarketingConsentText?: Maybe<Scalars["String"]["output"]>;
    campaignPrivacyConsentText?: Maybe<Scalars["String"]["output"]>;
    config?: Maybe<TenantConfig>;
    domainName?: Maybe<Scalars["String"]["output"]>;
    id?: Maybe<Scalars["String"]["output"]>;
    locale?: Maybe<Scalars["String"]["output"]>;
    logo?: Maybe<File>;
    name?: Maybe<Scalars["String"]["output"]>;
    stamp?: Maybe<TenantStamp>;
    tenantId?: Maybe<Scalars["String"]["output"]>;
    type?: Maybe<TenantType>;
};

export type TenantAgreements = {
    __typename?: "TenantAgreements";
    dsa?: Maybe<Agreement>;
    newsletter?: Maybe<Array<Agreement>>;
    privacyPolicy?: Maybe<Agreement>;
    signUp?: Maybe<Array<Agreement>>;
    termsOfService?: Maybe<Agreement>;
};

export type TenantConfig = {
    __typename?: "TenantConfig";
    layout?: Maybe<TenantLayout>;
    notifications?: Maybe<TenantNotificationsConfig>;
    reviewDestinations?: Maybe<Array<ReviewDestination>>;
    seo?: Maybe<TenantSeoConfig>;
    theme?: Maybe<TenantTheme>;
};

export type TenantItems = {
    __typename?: "TenantItems";
    items?: Maybe<Array<Tenant>>;
    nextToken?: Maybe<Scalars["String"]["output"]>;
};

export type TenantLayout = {
    __typename?: "TenantLayout";
    config?: Maybe<Scalars["String"]["output"]>;
    template?: Maybe<TenantLayoutTemplate>;
};

export const TenantLayoutTemplate = {
    Main: "main",
    Simplelandingpage: "simplelandingpage",
} as const;

export type TenantLayoutTemplate = (typeof TenantLayoutTemplate)[keyof typeof TenantLayoutTemplate];
export type TenantNotificationSettings = {
    __typename?: "TenantNotificationSettings";
    dueReviewNotificationDays?: Maybe<Array<Scalars["Int"]["output"]>>;
    enableBlacklistNotification?: Maybe<Scalars["Boolean"]["output"]>;
    enableCampaignApplicationAlternateNotification?: Maybe<Scalars["Boolean"]["output"]>;
    enableCampaignApplicationRejectedNotification?: Maybe<Scalars["Boolean"]["output"]>;
    enableCampaignApplicationSelectedNotification?: Maybe<Scalars["Boolean"]["output"]>;
    enableDueReviewNotification?: Maybe<Scalars["Boolean"]["output"]>;
    enableOverdueReviewNotification?: Maybe<Scalars["Boolean"]["output"]>;
    enableReviewApprovedNotification?: Maybe<Scalars["Boolean"]["output"]>;
    enableReviewCensuredNotification?: Maybe<Scalars["Boolean"]["output"]>;
    enableReviewRejectedNotification?: Maybe<Scalars["Boolean"]["output"]>;
    enableUnblacklistNotification?: Maybe<Scalars["Boolean"]["output"]>;
    enableWelcomeEmail?: Maybe<Scalars["Boolean"]["output"]>;
};

export type TenantNotificationsConfig = {
    __typename?: "TenantNotificationsConfig";
    defaultFrom?: Maybe<Scalars["String"]["output"]>;
    emailTemplates?: Maybe<EmailTemplateItems>;
    mailgunDomain?: Maybe<Scalars["String"]["output"]>;
    settings?: Maybe<TenantNotificationSettings>;
    tenantId?: Maybe<Scalars["String"]["output"]>;
};

export type TenantNotificationsConfigEmailTemplatesArgs = {
    limit?: InputMaybe<Scalars["Int"]["input"]>;
    name?: InputMaybe<Scalars["String"]["input"]>;
    nextToken?: InputMaybe<Scalars["String"]["input"]>;
};

export type TenantSeoConfig = {
    __typename?: "TenantSEOConfig";
    customScriptHead?: Maybe<Scalars["String"]["output"]>;
    gtmId?: Maybe<Scalars["String"]["output"]>;
    gtmLoadAfterInteractive?: Maybe<Scalars["Boolean"]["output"]>;
};

export type TenantSeoConfigInput = {
    customScriptHead?: InputMaybe<Scalars["String"]["input"]>;
    gtmId?: InputMaybe<Scalars["String"]["input"]>;
    gtmLoadAfterInteractive?: InputMaybe<Scalars["Boolean"]["input"]>;
};

export type TenantStamp = {
    __typename?: "TenantStamp";
    file?: Maybe<File>;
    height?: Maybe<Scalars["Float"]["output"]>;
    ratingColor?: Maybe<Scalars["String"]["output"]>;
    ratingFont?: Maybe<Scalars["String"]["output"]>;
    ratingHeight?: Maybe<Scalars["Float"]["output"]>;
    ratingTop?: Maybe<Scalars["Float"]["output"]>;
    rotationDeg?: Maybe<Scalars["Int"]["output"]>;
    width?: Maybe<Scalars["Float"]["output"]>;
};

export type TenantTheme = {
    __typename?: "TenantTheme";
    colorScheme?: Maybe<TenantThemeColorScheme>;
    favIcon?: Maybe<TenantThemeFavIcon>;
    fontFamily?: Maybe<Scalars["String"]["output"]>;
};

export type TenantThemeColorScheme = {
    __typename?: "TenantThemeColorScheme";
    primary?: Maybe<Scalars["String"]["output"]>;
    secondary?: Maybe<Scalars["String"]["output"]>;
};

export type TenantThemeFavIcon = {
    __typename?: "TenantThemeFavIcon";
    file?: Maybe<File>;
};

export const TenantType = {
    Community: "community",
    Main: "main",
} as const;

export type TenantType = (typeof TenantType)[keyof typeof TenantType];
export type UpdateCampaignInput = {
    additionalImages?: InputMaybe<Array<CampaignImageInput>>;
    clientId?: InputMaybe<Scalars["String"]["input"]>;
    description?: InputMaybe<RichTextInput>;
    displayTenantIds?: InputMaybe<Array<Scalars["String"]["input"]>>;
    mainTenantId: Scalars["String"]["input"];
    name?: InputMaybe<Scalars["String"]["input"]>;
    slug?: InputMaybe<Scalars["String"]["input"]>;
    tags?: InputMaybe<Array<CampaignTagInput>>;
};

export type UpdateCampaignProductsInput = {
    productIds?: InputMaybe<Array<Scalars["String"]["input"]>>;
    productReviewDestinations?: InputMaybe<Array<ProductReviewDestinationInput>>;
};

export type UpdateProductInput = {
    info?: InputMaybe<ProductInfoInput>;
};

export type UpdateProductLocaleInput = {
    attributes?: InputMaybe<Array<ProductAttributeInput>>;
    description?: InputMaybe<RichTextInput>;
    detailPageLinks?: InputMaybe<Array<ProductLinkInput>>;
    name: Scalars["String"]["input"];
    reviewFocusInstructions?: InputMaybe<RichTextInput>;
    slug: Scalars["String"]["input"];
    userManualLink?: InputMaybe<Scalars["String"]["input"]>;
};

export type User = {
    __typename?: "User";
    id?: Maybe<Scalars["String"]["output"]>;
    user?: Maybe<UserUnion>;
    userType?: Maybe<Scalars["String"]["output"]>;
};

export type UserUnion = ClientUser | CognitoUser;

export type AgreementItemFieldsFragment = {
    __typename?: "Agreement";
    id?: string | null;
    type?: AgreementType | null;
    name?: string | null;
    currentRevisionIndex?: number | null;
    latestRevisionIndex?: number | null;
    currentRevision?: {
        __typename?: "AgreementRevision";
        index?: number | null;
        createdAt?: number | null;
        label?: string | null;
        isOptional?: boolean | null;
        isPreselected?: boolean | null;
    } | null;
    revisions?: Array<{ __typename?: "AgreementRevision"; index?: number | null; createdAt?: number | null }> | null;
};

export type AgreementDetailFieldsFragment = {
    __typename?: "Agreement";
    id?: string | null;
    type?: AgreementType | null;
    name?: string | null;
    currentRevisionIndex?: number | null;
    latestRevisionIndex?: number | null;
    currentRevision?: {
        __typename?: "AgreementRevision";
        index?: number | null;
        createdAt?: number | null;
        label?: string | null;
        isOptional?: boolean | null;
        isPreselected?: boolean | null;
        content?: { __typename?: "RichText"; json?: string | null } | null;
    } | null;
    revisions?: Array<{
        __typename?: "AgreementRevision";
        index?: number | null;
        createdAt?: number | null;
        label?: string | null;
        isOptional?: boolean | null;
        isPreselected?: boolean | null;
    }> | null;
};

export type ApiKeyFieldsFragment = {
    __typename?: "APIKey";
    id?: string | null;
    name?: string | null;
    value?: string | null;
    createdAt?: number | null;
    expiresAt?: number | null;
};

export type CreateApiKeyMutationVariables = Exact<{
    clientId: Scalars["String"]["input"];
    name: Scalars["String"]["input"];
    expiresAt?: InputMaybe<Scalars["Float"]["input"]>;
}>;

export type CreateApiKeyMutation = {
    __typename?: "Mutation";
    createAPIKey?: {
        __typename?: "APIKey";
        id?: string | null;
        name?: string | null;
        value?: string | null;
        createdAt?: number | null;
        expiresAt?: number | null;
    } | null;
};

export type DeleteApiKeyMutationVariables = Exact<{
    clientId: Scalars["String"]["input"];
    apiKeyId: Scalars["String"]["input"];
}>;

export type DeleteApiKeyMutation = {
    __typename?: "Mutation";
    deleteAPIKey?: {
        __typename?: "APIKey";
        id?: string | null;
        name?: string | null;
        value?: string | null;
        createdAt?: number | null;
        expiresAt?: number | null;
    } | null;
};

export type ApiKeysQueryVariables = Exact<{
    clientId: Scalars["String"]["input"];
}>;

export type ApiKeysQuery = {
    __typename?: "Query";
    client?: {
        __typename?: "Client";
        api?: {
            __typename?: "API";
            apiKeys?: Array<{
                __typename?: "APIKey";
                id?: string | null;
                name?: string | null;
                value?: string | null;
                createdAt?: number | null;
                expiresAt?: number | null;
            }> | null;
        } | null;
    } | null;
};

export type ResetPasswordMutationVariables = Exact<{
    email: Scalars["String"]["input"];
}>;

export type ResetPasswordMutation = { __typename?: "Mutation"; resetPassword?: string | null };

export type CurrentUserQueryVariables = Exact<{ [key: string]: never }>;

export type CurrentUserQuery = {
    __typename?: "Query";
    currentUser?: {
        __typename?: "ClientUser";
        id?: string | null;
        email?: string | null;
        firstName?: string | null;
        lastName?: string | null;
    } | null;
};

export type CampaignInquiryItemFieldsFragment = {
    __typename?: "CampaignInquiry";
    id?: string | null;
    createdAt?: number | null;
    name?: string | null;
    settings?: { __typename?: "CampaignInquirySettings"; capacity?: number | null; openAt?: number | null } | null;
    client?: { __typename?: "Client"; id?: string | null; name?: string | null } | null;
    tenant?: {
        __typename?: "Tenant";
        id?: string | null;
        name?: string | null;
        domainName?: string | null;
        locale?: string | null;
        logo?: { __typename?: "File"; src?: string | null } | null;
    } | null;
    displayTenants?: Array<{
        __typename?: "Tenant";
        id?: string | null;
        name?: string | null;
        domainName?: string | null;
        locale?: string | null;
        logo?: { __typename?: "File"; src?: string | null } | null;
    }> | null;
    mainTenant?: {
        __typename?: "Tenant";
        id?: string | null;
        name?: string | null;
        domainName?: string | null;
        locale?: string | null;
        logo?: { __typename?: "File"; src?: string | null } | null;
    } | null;
    products?: Array<{
        __typename?: "CampaignInquiryProduct";
        key?: string | null;
        id?: string | null;
        name?: string | null;
    }> | null;
};

export type CampaignInquiryDetailFieldsFragment = {
    __typename?: "CampaignInquiry";
    id?: string | null;
    createdAt?: number | null;
    name?: string | null;
    additionalNotes?: string | null;
    settings?: { __typename?: "CampaignInquirySettings"; capacity?: number | null; openAt?: number | null } | null;
    tags?: Array<{
        __typename?: "CampaignTag";
        key?: string | null;
        text?: string | null;
        color?: string | null;
    }> | null;
    description?: {
        __typename?: "RichText";
        json?: string | null;
        images?: Array<{
            __typename?: "File";
            id?: string | null;
            src?: string | null;
            objectKey?: string | null;
        }> | null;
    } | null;
    client?: { __typename?: "Client"; id?: string | null; name?: string | null } | null;
    tenant?: {
        __typename?: "Tenant";
        id?: string | null;
        name?: string | null;
        domainName?: string | null;
        locale?: string | null;
        logo?: { __typename?: "File"; src?: string | null } | null;
    } | null;
    displayTenants?: Array<{
        __typename?: "Tenant";
        id?: string | null;
        name?: string | null;
        domainName?: string | null;
        locale?: string | null;
        logo?: { __typename?: "File"; src?: string | null } | null;
    }> | null;
    mainTenant?: {
        __typename?: "Tenant";
        id?: string | null;
        name?: string | null;
        domainName?: string | null;
        locale?: string | null;
        logo?: { __typename?: "File"; src?: string | null } | null;
    } | null;
    products?: Array<{
        __typename?: "CampaignInquiryProduct";
        key?: string | null;
        id?: string | null;
        ean?: string | null;
        name?: string | null;
        userManualLink?: string | null;
        category?: {
            __typename?: "ProductCategory";
            key?: string | null;
            parent?: { __typename?: "ProductCategory"; key?: string | null } | null;
        } | null;
        info?: {
            __typename?: "CampaignInquiryProductInfo";
            manufacturer?: string | null;
            model?: string | null;
        } | null;
        description?: {
            __typename?: "RichText";
            json?: string | null;
            images?: Array<{
                __typename?: "File";
                id?: string | null;
                objectKey?: string | null;
                src?: string | null;
            }> | null;
        } | null;
        destinations?: Array<{
            __typename?: "ReviewDestination";
            type?: string | null;
            key?: string | null;
            name?: string | null;
            config?: string | null;
            isOrderNumber?: boolean | null;
            configFields?: Array<{
                __typename?: "ReviewDestinationConfigField";
                type?: ReviewDestinationConfigFieldType | null;
                path?: string | null;
                label?: string | null;
                placeholder?: string | null;
                isRequiredForApproval?: boolean | null;
                urlStripQueryString?: boolean | null;
            }> | null;
        } | null> | null;
        detailPageLinks?: Array<{ __typename?: "ProductLink"; label?: string | null; src?: string | null }> | null;
        reviewFocusInstructions?: {
            __typename?: "RichText";
            json?: string | null;
            images?: Array<{
                __typename?: "File";
                id?: string | null;
                src?: string | null;
                objectKey?: string | null;
            }> | null;
        } | null;
        images?: Array<{
            __typename?: "File";
            id?: string | null;
            src?: string | null;
            objectKey?: string | null;
        }> | null;
        attributes?: Array<{
            __typename?: "ProductAttribute";
            id?: string | null;
            name?: string | null;
            locale?: string | null;
        }> | null;
        thumbnailImage?: {
            __typename?: "File";
            id?: string | null;
            objectKey?: string | null;
            src?: string | null;
        } | null;
    }> | null;
    delivery?: {
        __typename?: "CampaignDelivery";
        freeOfCharge?: boolean | null;
        type?: string | null;
        notes?: string | null;
        instructions?: {
            __typename?: "RichText";
            json?: string | null;
            images?: Array<{
                __typename?: "File";
                id?: string | null;
                src?: string | null;
                objectKey?: string | null;
            }> | null;
        } | null;
    } | null;
    pricing?: {
        __typename?: "CampaignPricing";
        isFree?: boolean | null;
        discountPercent?: number | null;
        discountCodes?: {
            __typename?: "CampaignDiscountCodeItems";
            items?: Array<{ __typename?: "CampaignDiscountCode"; code?: string | null }> | null;
        } | null;
    } | null;
    outcome?: {
        __typename?: "CampaignOutcome";
        includeImages?: boolean | null;
        includeVideo?: boolean | null;
        includeSocialPosts?: boolean | null;
        hashtags?: Array<string> | null;
        fbMentions?: Array<string> | null;
        igMentions?: Array<string> | null;
    } | null;
    questionnaire?: {
        __typename?: "Questionnaire";
        id?: string | null;
        criteria?: Array<{
            __typename?: "QuestionCriteria";
            dependsOn?: string | null;
            note?: string | null;
            requiredValue?: string | null;
            type?: QuestionConditionType | null;
        } | null> | null;
        questions?: Array<{
            __typename?: "Question";
            key?: string | null;
            type?: QuestionType | null;
            isOptional?: boolean | null;
            text?: string | null;
            condition?: {
                __typename?: "QuestionCondition";
                dependsOn?: string | null;
                requiredValue?: string | null;
                type?: QuestionConditionType | null;
            } | null;
            options?: Array<{ __typename?: "QuestionOption"; key?: string | null; text?: string | null } | null> | null;
        } | null> | null;
    } | null;
    images?: Array<{
        __typename?: "CampaignImage";
        file?: { __typename?: "File"; id?: string | null; src?: string | null; objectKey?: string | null } | null;
    }> | null;
    restrictions?: {
        __typename?: "CampaignRestrictions";
        ageMax?: number | null;
        ageMin?: number | null;
        gender?: Gender | null;
        location?: {
            __typename?: "Address";
            city?: string | null;
            country?: string | null;
            postalCode?: string | null;
            line1?: string | null;
            line2?: string | null;
        } | null;
    } | null;
    thumbnailImage?: { __typename?: "File"; id?: string | null; src?: string | null; objectKey?: string | null } | null;
};

export type CreateCampaignInquiryMutationVariables = Exact<{
    campaignInquiry: CreateCampaignInquiryInput;
}>;

export type CreateCampaignInquiryMutation = {
    __typename?: "Mutation";
    createCampaignInquiry?: { __typename?: "CampaignInquiry"; id?: string | null } | null;
};

export type CampaignInquiriesQueryVariables = Exact<{
    client: Scalars["String"]["input"];
    resolved?: InputMaybe<Scalars["Boolean"]["input"]>;
    limit?: InputMaybe<Scalars["Int"]["input"]>;
    nextToken?: InputMaybe<Scalars["String"]["input"]>;
}>;

export type CampaignInquiriesQuery = {
    __typename?: "Query";
    campaignInquiries?: {
        __typename?: "CampaignInquiryItems";
        nextToken?: string | null;
        items?: Array<{
            __typename?: "CampaignInquiry";
            id?: string | null;
            createdAt?: number | null;
            name?: string | null;
            settings?: {
                __typename?: "CampaignInquirySettings";
                capacity?: number | null;
                openAt?: number | null;
            } | null;
            client?: { __typename?: "Client"; id?: string | null; name?: string | null } | null;
            tenant?: {
                __typename?: "Tenant";
                id?: string | null;
                name?: string | null;
                domainName?: string | null;
                locale?: string | null;
                logo?: { __typename?: "File"; src?: string | null } | null;
            } | null;
            displayTenants?: Array<{
                __typename?: "Tenant";
                id?: string | null;
                name?: string | null;
                domainName?: string | null;
                locale?: string | null;
                logo?: { __typename?: "File"; src?: string | null } | null;
            }> | null;
            mainTenant?: {
                __typename?: "Tenant";
                id?: string | null;
                name?: string | null;
                domainName?: string | null;
                locale?: string | null;
                logo?: { __typename?: "File"; src?: string | null } | null;
            } | null;
            products?: Array<{
                __typename?: "CampaignInquiryProduct";
                key?: string | null;
                id?: string | null;
                name?: string | null;
            }> | null;
        }> | null;
    } | null;
};

export type CampaignInquiryQueryVariables = Exact<{
    campaignInquiryId: Scalars["String"]["input"];
}>;

export type CampaignInquiryQuery = {
    __typename?: "Query";
    campaignInquiry?: {
        __typename?: "CampaignInquiry";
        id?: string | null;
        createdAt?: number | null;
        name?: string | null;
        additionalNotes?: string | null;
        settings?: { __typename?: "CampaignInquirySettings"; capacity?: number | null; openAt?: number | null } | null;
        tags?: Array<{
            __typename?: "CampaignTag";
            key?: string | null;
            text?: string | null;
            color?: string | null;
        }> | null;
        description?: {
            __typename?: "RichText";
            json?: string | null;
            images?: Array<{
                __typename?: "File";
                id?: string | null;
                src?: string | null;
                objectKey?: string | null;
            }> | null;
        } | null;
        client?: { __typename?: "Client"; id?: string | null; name?: string | null } | null;
        tenant?: {
            __typename?: "Tenant";
            id?: string | null;
            name?: string | null;
            domainName?: string | null;
            locale?: string | null;
            logo?: { __typename?: "File"; src?: string | null } | null;
        } | null;
        displayTenants?: Array<{
            __typename?: "Tenant";
            id?: string | null;
            name?: string | null;
            domainName?: string | null;
            locale?: string | null;
            logo?: { __typename?: "File"; src?: string | null } | null;
        }> | null;
        mainTenant?: {
            __typename?: "Tenant";
            id?: string | null;
            name?: string | null;
            domainName?: string | null;
            locale?: string | null;
            logo?: { __typename?: "File"; src?: string | null } | null;
        } | null;
        products?: Array<{
            __typename?: "CampaignInquiryProduct";
            key?: string | null;
            id?: string | null;
            ean?: string | null;
            name?: string | null;
            userManualLink?: string | null;
            category?: {
                __typename?: "ProductCategory";
                key?: string | null;
                parent?: { __typename?: "ProductCategory"; key?: string | null } | null;
            } | null;
            info?: {
                __typename?: "CampaignInquiryProductInfo";
                manufacturer?: string | null;
                model?: string | null;
            } | null;
            description?: {
                __typename?: "RichText";
                json?: string | null;
                images?: Array<{
                    __typename?: "File";
                    id?: string | null;
                    objectKey?: string | null;
                    src?: string | null;
                }> | null;
            } | null;
            destinations?: Array<{
                __typename?: "ReviewDestination";
                type?: string | null;
                key?: string | null;
                name?: string | null;
                config?: string | null;
                isOrderNumber?: boolean | null;
                configFields?: Array<{
                    __typename?: "ReviewDestinationConfigField";
                    type?: ReviewDestinationConfigFieldType | null;
                    path?: string | null;
                    label?: string | null;
                    placeholder?: string | null;
                    isRequiredForApproval?: boolean | null;
                    urlStripQueryString?: boolean | null;
                }> | null;
            } | null> | null;
            detailPageLinks?: Array<{ __typename?: "ProductLink"; label?: string | null; src?: string | null }> | null;
            reviewFocusInstructions?: {
                __typename?: "RichText";
                json?: string | null;
                images?: Array<{
                    __typename?: "File";
                    id?: string | null;
                    src?: string | null;
                    objectKey?: string | null;
                }> | null;
            } | null;
            images?: Array<{
                __typename?: "File";
                id?: string | null;
                src?: string | null;
                objectKey?: string | null;
            }> | null;
            attributes?: Array<{
                __typename?: "ProductAttribute";
                id?: string | null;
                name?: string | null;
                locale?: string | null;
            }> | null;
            thumbnailImage?: {
                __typename?: "File";
                id?: string | null;
                objectKey?: string | null;
                src?: string | null;
            } | null;
        }> | null;
        delivery?: {
            __typename?: "CampaignDelivery";
            freeOfCharge?: boolean | null;
            type?: string | null;
            notes?: string | null;
            instructions?: {
                __typename?: "RichText";
                json?: string | null;
                images?: Array<{
                    __typename?: "File";
                    id?: string | null;
                    src?: string | null;
                    objectKey?: string | null;
                }> | null;
            } | null;
        } | null;
        pricing?: {
            __typename?: "CampaignPricing";
            isFree?: boolean | null;
            discountPercent?: number | null;
            discountCodes?: {
                __typename?: "CampaignDiscountCodeItems";
                items?: Array<{ __typename?: "CampaignDiscountCode"; code?: string | null }> | null;
            } | null;
        } | null;
        outcome?: {
            __typename?: "CampaignOutcome";
            includeImages?: boolean | null;
            includeVideo?: boolean | null;
            includeSocialPosts?: boolean | null;
            hashtags?: Array<string> | null;
            fbMentions?: Array<string> | null;
            igMentions?: Array<string> | null;
        } | null;
        questionnaire?: {
            __typename?: "Questionnaire";
            id?: string | null;
            criteria?: Array<{
                __typename?: "QuestionCriteria";
                dependsOn?: string | null;
                note?: string | null;
                requiredValue?: string | null;
                type?: QuestionConditionType | null;
            } | null> | null;
            questions?: Array<{
                __typename?: "Question";
                key?: string | null;
                type?: QuestionType | null;
                isOptional?: boolean | null;
                text?: string | null;
                condition?: {
                    __typename?: "QuestionCondition";
                    dependsOn?: string | null;
                    requiredValue?: string | null;
                    type?: QuestionConditionType | null;
                } | null;
                options?: Array<{
                    __typename?: "QuestionOption";
                    key?: string | null;
                    text?: string | null;
                } | null> | null;
            } | null> | null;
        } | null;
        images?: Array<{
            __typename?: "CampaignImage";
            file?: { __typename?: "File"; id?: string | null; src?: string | null; objectKey?: string | null } | null;
        }> | null;
        restrictions?: {
            __typename?: "CampaignRestrictions";
            ageMax?: number | null;
            ageMin?: number | null;
            gender?: Gender | null;
            location?: {
                __typename?: "Address";
                city?: string | null;
                country?: string | null;
                postalCode?: string | null;
                line1?: string | null;
                line2?: string | null;
            } | null;
        } | null;
        thumbnailImage?: {
            __typename?: "File";
            id?: string | null;
            src?: string | null;
            objectKey?: string | null;
        } | null;
    } | null;
};

export type CampaignResultsExportJobsQueryVariables = Exact<{
    campaignId: Scalars["String"]["input"];
    clientId: Scalars["String"]["input"];
}>;

export type CampaignResultsExportJobsQuery = {
    __typename?: "Query";
    campaign?: {
        __typename?: "Campaign";
        id?: string | null;
        resultsExportJobs?: Array<{
            __typename?: "ExportJob";
            id?: string | null;
            paramsJson?: string | null;
            state?: string | null;
            startedAt?: number | null;
            finishedAt?: number | null;
            objectKey?: string | null;
            downloadUrl?: string | null;
            errorJson?: string | null;
            stats?: {
                __typename?: "ExportJobStats";
                originalBytes?: number | null;
                compressedBytes?: number | null;
            } | null;
        }> | null;
    } | null;
};

export type CampaignItemFieldsFragment = {
    __typename?: "Campaign";
    id?: string | null;
    state?: CampaignState | null;
    slug?: string | null;
    name?: string | null;
    totalApplicationsCount?: number | null;
    unresolvedApplicationsCount?: number | null;
    selectedApplicationsCount?: number | null;
    tenant?: {
        __typename?: "Tenant";
        id?: string | null;
        locale?: string | null;
        name?: string | null;
        domainName?: string | null;
    } | null;
    displayTenants?: Array<{
        __typename?: "Tenant";
        id?: string | null;
        locale?: string | null;
        name?: string | null;
        domainName?: string | null;
    }> | null;
    mainTenant?: {
        __typename?: "Tenant";
        id?: string | null;
        locale?: string | null;
        name?: string | null;
        domainName?: string | null;
    } | null;
    products?: Array<{
        __typename?: "Product";
        id?: string | null;
        name?: string | null;
        category?: { __typename?: "ProductCategory"; key?: string | null } | null;
        info?: {
            __typename?: "ProductInfo";
            model?: string | null;
            manufacturer?: {
                __typename?: "Manufacturer";
                id?: string | null;
                name?: string | null;
                logo?: { __typename?: "File"; src?: string | null } | null;
            } | null;
        } | null;
    }> | null;
    settings?: {
        __typename?: "CampaignSettings";
        capacity?: number | null;
        openAt?: number | null;
        closeAt?: number | null;
        registrationPeriodDays?: number | null;
        submissionPeriodDays?: number | null;
    } | null;
    thumbnailImage?: { __typename?: "File"; id?: string | null; src?: string | null } | null;
};

export type CampaignDetailFieldsFragment = {
    __typename?: "Campaign";
    id?: string | null;
    state?: CampaignState | null;
    slug?: string | null;
    name?: string | null;
    isHidden?: boolean | null;
    isTopped?: boolean | null;
    totalApplicationsCount?: number | null;
    unresolvedApplicationsCount?: number | null;
    selectedApplicationsCount?: number | null;
    clientNote?: string | null;
    client?: { __typename?: "Client"; id?: string | null; name?: string | null } | null;
    tenant?: {
        __typename?: "Tenant";
        id?: string | null;
        locale?: string | null;
        name?: string | null;
        domainName?: string | null;
    } | null;
    displayTenants?: Array<{
        __typename?: "Tenant";
        id?: string | null;
        locale?: string | null;
        name?: string | null;
        domainName?: string | null;
    }> | null;
    mainTenant?: {
        __typename?: "Tenant";
        id?: string | null;
        locale?: string | null;
        name?: string | null;
        domainName?: string | null;
    } | null;
    products?: Array<{
        __typename?: "Product";
        id?: string | null;
        name?: string | null;
        userManualLink?: string | null;
        codes?: { __typename?: "ProductCodes"; ean?: string | null } | null;
        images?: Array<{
            __typename?: "File";
            id?: string | null;
            objectKey?: string | null;
            src?: string | null;
        }> | null;
        category?: {
            __typename?: "ProductCategory";
            key?: string | null;
            parent?: { __typename?: "ProductCategory"; key?: string | null } | null;
        } | null;
        attributes?: Array<{
            __typename?: "ProductAttribute";
            id?: string | null;
            name?: string | null;
            locale?: string | null;
        }> | null;
        info?: {
            __typename?: "ProductInfo";
            model?: string | null;
            manufacturer?: {
                __typename?: "Manufacturer";
                id?: string | null;
                name?: string | null;
                logo?: { __typename?: "File"; src?: string | null } | null;
            } | null;
        } | null;
        thumbnailImage?: {
            __typename?: "File";
            id?: string | null;
            src?: string | null;
            objectKey?: string | null;
        } | null;
        description?: {
            __typename?: "RichText";
            json?: string | null;
            images?: Array<{
                __typename?: "File";
                id?: string | null;
                objectKey?: string | null;
                src?: string | null;
            }> | null;
        } | null;
        detailPageLinks?: Array<{ __typename?: "ProductLink"; label?: string | null; src?: string | null }> | null;
        reviewFocusInstructions?: {
            __typename?: "RichText";
            json?: string | null;
            images?: Array<{
                __typename?: "File";
                id?: string | null;
                objectKey?: string | null;
                src?: string | null;
            }> | null;
        } | null;
    }> | null;
    productReviewDestinations?: Array<{
        __typename?: "ProductReviewDestination";
        productId?: string | null;
        destinations?: Array<{
            __typename?: "ReviewDestination";
            type?: string | null;
            key?: string | null;
            name?: string | null;
            config?: string | null;
            isOrderNumber?: boolean | null;
            configFields?: Array<{
                __typename?: "ReviewDestinationConfigField";
                type?: ReviewDestinationConfigFieldType | null;
                path?: string | null;
                label?: string | null;
                placeholder?: string | null;
                isRequiredForApproval?: boolean | null;
                urlStripQueryString?: boolean | null;
            }> | null;
        }> | null;
    }> | null;
    tags?: Array<{
        __typename?: "CampaignTag";
        key?: string | null;
        text?: string | null;
        color?: string | null;
    }> | null;
    description?: { __typename?: "RichText"; json?: string | null } | null;
    settings?: {
        __typename?: "CampaignSettings";
        capacity?: number | null;
        openAt?: number | null;
        closeAt?: number | null;
        registrationPeriodDays?: number | null;
        submissionPeriodDays?: number | null;
    } | null;
    restrictions?: {
        __typename?: "CampaignRestrictions";
        gender?: Gender | null;
        ageMin?: number | null;
        ageMax?: number | null;
        location?: {
            __typename?: "Address";
            country?: string | null;
            city?: string | null;
            line1?: string | null;
            line2?: string | null;
            postalCode?: string | null;
        } | null;
    } | null;
    outcome?: {
        __typename?: "CampaignOutcome";
        includeImages?: boolean | null;
        includeVideo?: boolean | null;
        includeSocialPosts?: boolean | null;
        hashtags?: Array<string> | null;
        fbMentions?: Array<string> | null;
        igMentions?: Array<string> | null;
    } | null;
    pricing?: {
        __typename?: "CampaignPricing";
        discountPercent?: number | null;
        isFree?: boolean | null;
        discountCodes?: {
            __typename?: "CampaignDiscountCodeItems";
            items?: Array<{ __typename?: "CampaignDiscountCode"; code?: string | null }> | null;
        } | null;
    } | null;
    delivery?: {
        __typename?: "CampaignDelivery";
        freeOfCharge?: boolean | null;
        type?: string | null;
        notes?: string | null;
        instructions?: {
            __typename?: "RichText";
            json?: string | null;
            images?: Array<{
                __typename?: "File";
                id?: string | null;
                objectKey?: string | null;
                src?: string | null;
            }> | null;
        } | null;
    } | null;
    questionnaire?: {
        __typename?: "Questionnaire";
        id?: string | null;
        criteria?: Array<{
            __typename?: "QuestionCriteria";
            dependsOn?: string | null;
            note?: string | null;
            requiredValue?: string | null;
            type?: QuestionConditionType | null;
        } | null> | null;
        questions?: Array<{
            __typename?: "Question";
            key?: string | null;
            isOptional?: boolean | null;
            text?: string | null;
            type?: QuestionType | null;
            condition?: {
                __typename?: "QuestionCondition";
                dependsOn?: string | null;
                requiredValue?: string | null;
                type?: QuestionConditionType | null;
            } | null;
            options?: Array<{ __typename?: "QuestionOption"; key?: string | null; text?: string | null } | null> | null;
        } | null> | null;
    } | null;
    thumbnailImage?: { __typename?: "File"; id?: string | null; objectKey?: string | null; src?: string | null } | null;
    images?: Array<{
        __typename?: "CampaignImage";
        file?: { __typename?: "File"; id?: string | null; objectKey?: string | null; src?: string | null } | null;
    }> | null;
    attachments?: Array<{
        __typename?: "CampaignAttachment";
        originalFilename?: string | null;
        file?: { __typename?: "File"; id?: string | null; src?: string | null } | null;
    }> | null;
    milestones?: Array<{ __typename?: "CampaignMilestone"; type?: string | null; timestamp?: number | null }> | null;
    results?: {
        __typename?: "CampaignResults";
        products?: Array<{
            __typename?: "CampaignProductResults";
            productId?: string | null;
            approvedCount?: number | null;
            rejectedCount?: number | null;
            censuredCount?: number | null;
            wouldRecommendCount?: number | null;
            wouldRecommendPercent?: number | null;
            totalRating?: number | null;
            totalRatingBreakup?: Array<{
                __typename?: "RatingBreakupItem";
                rating?: number | null;
                count?: number | null;
            }> | null;
            attributeRatings?: Array<{
                __typename?: "ProductAttributeRating";
                id?: string | null;
                name?: string | null;
                rating?: number | null;
            }> | null;
        }> | null;
    } | null;
};

export type ApproveCampaignMutationVariables = Exact<{
    campaignId: Scalars["String"]["input"];
}>;

export type ApproveCampaignMutation = {
    __typename?: "Mutation";
    approveCampaign?: { __typename?: "Campaign"; id?: string | null } | null;
};

export type CampaignsQueryVariables = Exact<{
    client: Scalars["String"]["input"];
    state?: InputMaybe<CampaignState>;
    limit?: InputMaybe<Scalars["Int"]["input"]>;
    nextToken?: InputMaybe<Scalars["String"]["input"]>;
}>;

export type CampaignsQuery = {
    __typename?: "Query";
    campaigns?: {
        __typename?: "CampaignItems";
        nextToken?: string | null;
        items?: Array<{
            __typename?: "Campaign";
            id?: string | null;
            state?: CampaignState | null;
            slug?: string | null;
            name?: string | null;
            totalApplicationsCount?: number | null;
            unresolvedApplicationsCount?: number | null;
            selectedApplicationsCount?: number | null;
            tenant?: {
                __typename?: "Tenant";
                id?: string | null;
                locale?: string | null;
                name?: string | null;
                domainName?: string | null;
            } | null;
            displayTenants?: Array<{
                __typename?: "Tenant";
                id?: string | null;
                locale?: string | null;
                name?: string | null;
                domainName?: string | null;
            }> | null;
            mainTenant?: {
                __typename?: "Tenant";
                id?: string | null;
                locale?: string | null;
                name?: string | null;
                domainName?: string | null;
            } | null;
            products?: Array<{
                __typename?: "Product";
                id?: string | null;
                name?: string | null;
                category?: { __typename?: "ProductCategory"; key?: string | null } | null;
                info?: {
                    __typename?: "ProductInfo";
                    model?: string | null;
                    manufacturer?: {
                        __typename?: "Manufacturer";
                        id?: string | null;
                        name?: string | null;
                        logo?: { __typename?: "File"; src?: string | null } | null;
                    } | null;
                } | null;
            }> | null;
            settings?: {
                __typename?: "CampaignSettings";
                capacity?: number | null;
                openAt?: number | null;
                closeAt?: number | null;
                registrationPeriodDays?: number | null;
                submissionPeriodDays?: number | null;
            } | null;
            thumbnailImage?: { __typename?: "File"; id?: string | null; src?: string | null } | null;
        }> | null;
    } | null;
};

export type CampaignQueryVariables = Exact<{
    campaignId: Scalars["String"]["input"];
}>;

export type CampaignQuery = {
    __typename?: "Query";
    campaign?: {
        __typename?: "Campaign";
        id?: string | null;
        state?: CampaignState | null;
        slug?: string | null;
        name?: string | null;
        isHidden?: boolean | null;
        isTopped?: boolean | null;
        totalApplicationsCount?: number | null;
        unresolvedApplicationsCount?: number | null;
        selectedApplicationsCount?: number | null;
        clientNote?: string | null;
        client?: { __typename?: "Client"; id?: string | null; name?: string | null } | null;
        tenant?: {
            __typename?: "Tenant";
            id?: string | null;
            locale?: string | null;
            name?: string | null;
            domainName?: string | null;
        } | null;
        displayTenants?: Array<{
            __typename?: "Tenant";
            id?: string | null;
            locale?: string | null;
            name?: string | null;
            domainName?: string | null;
        }> | null;
        mainTenant?: {
            __typename?: "Tenant";
            id?: string | null;
            locale?: string | null;
            name?: string | null;
            domainName?: string | null;
        } | null;
        products?: Array<{
            __typename?: "Product";
            id?: string | null;
            name?: string | null;
            userManualLink?: string | null;
            codes?: { __typename?: "ProductCodes"; ean?: string | null } | null;
            images?: Array<{
                __typename?: "File";
                id?: string | null;
                objectKey?: string | null;
                src?: string | null;
            }> | null;
            category?: {
                __typename?: "ProductCategory";
                key?: string | null;
                parent?: { __typename?: "ProductCategory"; key?: string | null } | null;
            } | null;
            attributes?: Array<{
                __typename?: "ProductAttribute";
                id?: string | null;
                name?: string | null;
                locale?: string | null;
            }> | null;
            info?: {
                __typename?: "ProductInfo";
                model?: string | null;
                manufacturer?: {
                    __typename?: "Manufacturer";
                    id?: string | null;
                    name?: string | null;
                    logo?: { __typename?: "File"; src?: string | null } | null;
                } | null;
            } | null;
            thumbnailImage?: {
                __typename?: "File";
                id?: string | null;
                src?: string | null;
                objectKey?: string | null;
            } | null;
            description?: {
                __typename?: "RichText";
                json?: string | null;
                images?: Array<{
                    __typename?: "File";
                    id?: string | null;
                    objectKey?: string | null;
                    src?: string | null;
                }> | null;
            } | null;
            detailPageLinks?: Array<{ __typename?: "ProductLink"; label?: string | null; src?: string | null }> | null;
            reviewFocusInstructions?: {
                __typename?: "RichText";
                json?: string | null;
                images?: Array<{
                    __typename?: "File";
                    id?: string | null;
                    objectKey?: string | null;
                    src?: string | null;
                }> | null;
            } | null;
        }> | null;
        productReviewDestinations?: Array<{
            __typename?: "ProductReviewDestination";
            productId?: string | null;
            destinations?: Array<{
                __typename?: "ReviewDestination";
                type?: string | null;
                key?: string | null;
                name?: string | null;
                config?: string | null;
                isOrderNumber?: boolean | null;
                configFields?: Array<{
                    __typename?: "ReviewDestinationConfigField";
                    type?: ReviewDestinationConfigFieldType | null;
                    path?: string | null;
                    label?: string | null;
                    placeholder?: string | null;
                    isRequiredForApproval?: boolean | null;
                    urlStripQueryString?: boolean | null;
                }> | null;
            }> | null;
        }> | null;
        tags?: Array<{
            __typename?: "CampaignTag";
            key?: string | null;
            text?: string | null;
            color?: string | null;
        }> | null;
        description?: { __typename?: "RichText"; json?: string | null } | null;
        settings?: {
            __typename?: "CampaignSettings";
            capacity?: number | null;
            openAt?: number | null;
            closeAt?: number | null;
            registrationPeriodDays?: number | null;
            submissionPeriodDays?: number | null;
        } | null;
        restrictions?: {
            __typename?: "CampaignRestrictions";
            gender?: Gender | null;
            ageMin?: number | null;
            ageMax?: number | null;
            location?: {
                __typename?: "Address";
                country?: string | null;
                city?: string | null;
                line1?: string | null;
                line2?: string | null;
                postalCode?: string | null;
            } | null;
        } | null;
        outcome?: {
            __typename?: "CampaignOutcome";
            includeImages?: boolean | null;
            includeVideo?: boolean | null;
            includeSocialPosts?: boolean | null;
            hashtags?: Array<string> | null;
            fbMentions?: Array<string> | null;
            igMentions?: Array<string> | null;
        } | null;
        pricing?: {
            __typename?: "CampaignPricing";
            discountPercent?: number | null;
            isFree?: boolean | null;
            discountCodes?: {
                __typename?: "CampaignDiscountCodeItems";
                items?: Array<{ __typename?: "CampaignDiscountCode"; code?: string | null }> | null;
            } | null;
        } | null;
        delivery?: {
            __typename?: "CampaignDelivery";
            freeOfCharge?: boolean | null;
            type?: string | null;
            notes?: string | null;
            instructions?: {
                __typename?: "RichText";
                json?: string | null;
                images?: Array<{
                    __typename?: "File";
                    id?: string | null;
                    objectKey?: string | null;
                    src?: string | null;
                }> | null;
            } | null;
        } | null;
        questionnaire?: {
            __typename?: "Questionnaire";
            id?: string | null;
            criteria?: Array<{
                __typename?: "QuestionCriteria";
                dependsOn?: string | null;
                note?: string | null;
                requiredValue?: string | null;
                type?: QuestionConditionType | null;
            } | null> | null;
            questions?: Array<{
                __typename?: "Question";
                key?: string | null;
                isOptional?: boolean | null;
                text?: string | null;
                type?: QuestionType | null;
                condition?: {
                    __typename?: "QuestionCondition";
                    dependsOn?: string | null;
                    requiredValue?: string | null;
                    type?: QuestionConditionType | null;
                } | null;
                options?: Array<{
                    __typename?: "QuestionOption";
                    key?: string | null;
                    text?: string | null;
                } | null> | null;
            } | null> | null;
        } | null;
        thumbnailImage?: {
            __typename?: "File";
            id?: string | null;
            objectKey?: string | null;
            src?: string | null;
        } | null;
        images?: Array<{
            __typename?: "CampaignImage";
            file?: { __typename?: "File"; id?: string | null; objectKey?: string | null; src?: string | null } | null;
        }> | null;
        attachments?: Array<{
            __typename?: "CampaignAttachment";
            originalFilename?: string | null;
            file?: { __typename?: "File"; id?: string | null; src?: string | null } | null;
        }> | null;
        milestones?: Array<{
            __typename?: "CampaignMilestone";
            type?: string | null;
            timestamp?: number | null;
        }> | null;
        results?: {
            __typename?: "CampaignResults";
            products?: Array<{
                __typename?: "CampaignProductResults";
                productId?: string | null;
                approvedCount?: number | null;
                rejectedCount?: number | null;
                censuredCount?: number | null;
                wouldRecommendCount?: number | null;
                wouldRecommendPercent?: number | null;
                totalRating?: number | null;
                totalRatingBreakup?: Array<{
                    __typename?: "RatingBreakupItem";
                    rating?: number | null;
                    count?: number | null;
                }> | null;
                attributeRatings?: Array<{
                    __typename?: "ProductAttributeRating";
                    id?: string | null;
                    name?: string | null;
                    rating?: number | null;
                }> | null;
            }> | null;
        } | null;
    } | null;
};

export type CampaignProductReviewDestinationsQueryVariables = Exact<{
    campaignId: Scalars["String"]["input"];
}>;

export type CampaignProductReviewDestinationsQuery = {
    __typename?: "Query";
    campaign?: {
        __typename?: "Campaign";
        id?: string | null;
        productReviewDestinations?: Array<{
            __typename?: "ProductReviewDestination";
            productId?: string | null;
            destinations?: Array<{
                __typename?: "ReviewDestination";
                type?: string | null;
                key?: string | null;
                name?: string | null;
                config?: string | null;
            }> | null;
        }> | null;
    } | null;
};

export type CampaignQuestionnaireQueryVariables = Exact<{
    campaignId: Scalars["String"]["input"];
}>;

export type CampaignQuestionnaireQuery = {
    __typename?: "Query";
    campaign?: {
        __typename?: "Campaign";
        id?: string | null;
        questionnaire?: {
            __typename?: "Questionnaire";
            id?: string | null;
            questions?: Array<{
                __typename?: "Question";
                key?: string | null;
                type?: QuestionType | null;
                isOptional?: boolean | null;
                text?: string | null;
                options?: Array<{
                    __typename?: "QuestionOption";
                    key?: string | null;
                    text?: string | null;
                } | null> | null;
            } | null> | null;
        } | null;
    } | null;
};

export type OnCampaignUpdateSubscriptionVariables = Exact<{
    campaignId: Scalars["String"]["input"];
}>;

export type OnCampaignUpdateSubscription = {
    __typename?: "Subscription";
    onCampaignUpdate?: { __typename?: "CampaignUpdate"; campaignId?: string | null; reason?: string | null } | null;
};

export type ClientItemFieldsFragment = {
    __typename?: "Client";
    id?: string | null;
    name?: string | null;
    maxQuestionnaireQuestions: number;
    billing?: { __typename?: "ClientBilling"; email?: string | null; cin?: string | null; tin?: string | null } | null;
};

export type ClientDetailFieldsFragment = {
    __typename?: "Client";
    id?: string | null;
    name?: string | null;
    maxQuestionnaireQuestions: number;
    billing?: {
        __typename?: "ClientBilling";
        name?: string | null;
        email?: string | null;
        cin?: string | null;
        tin?: string | null;
        address?: {
            __typename?: "Address";
            country?: string | null;
            postalCode?: string | null;
            city?: string | null;
            line1?: string | null;
            line2?: string | null;
        } | null;
    } | null;
};

export type ClientUserFieldsFragment = {
    __typename?: "ClientUser";
    id?: string | null;
    firstName?: string | null;
    lastName?: string | null;
    email?: string | null;
    role?: ClientUserRole | null;
    locale?: string | null;
};

export type StripeInvoiceFieldsFragment = {
    __typename?: "StripeInvoice";
    id?: string | null;
    status?: string | null;
    amount_due?: number | null;
    amount_paid?: number | null;
    amount_remaining?: number | null;
    amount_shipping?: number | null;
    total?: number | null;
    total_excluding_tax?: number | null;
    subtotal?: number | null;
    subtotal_excluding_tax?: number | null;
    tax?: number | null;
    attempt_count?: number | null;
    attempted?: boolean | null;
    auto_advance?: boolean | null;
    billing_reason?: string | null;
    collection_method?: string | null;
    created?: number | null;
    currency?: string | null;
    description?: string | null;
    due_date?: number | null;
    effective_at?: number | null;
    ending_balance?: number | null;
    footer?: string | null;
    hosted_invoice_url?: string | null;
    invoice_pdf?: string | null;
    number?: string | null;
    paid?: boolean | null;
    period_start?: number | null;
    period_end?: number | null;
};

export type StripeInvoiceItemFieldsFragment = {
    __typename?: "StripeInvoiceItem";
    id?: string | null;
    amount?: number | null;
    amount_excluding_tax?: number | null;
    currency?: string | null;
    description?: string | null;
    type?: string | null;
};

export type InvoiceFieldsFragment = {
    __typename?: "Invoice";
    id?: string | null;
    createdAt?: number | null;
    type?: string | null;
    stripeInvoice?: {
        __typename?: "StripeInvoice";
        id?: string | null;
        status?: string | null;
        amount_due?: number | null;
        amount_paid?: number | null;
        amount_remaining?: number | null;
        amount_shipping?: number | null;
        total?: number | null;
        total_excluding_tax?: number | null;
        subtotal?: number | null;
        subtotal_excluding_tax?: number | null;
        tax?: number | null;
        attempt_count?: number | null;
        attempted?: boolean | null;
        auto_advance?: boolean | null;
        billing_reason?: string | null;
        collection_method?: string | null;
        created?: number | null;
        currency?: string | null;
        description?: string | null;
        due_date?: number | null;
        effective_at?: number | null;
        ending_balance?: number | null;
        footer?: string | null;
        hosted_invoice_url?: string | null;
        invoice_pdf?: string | null;
        number?: string | null;
        paid?: boolean | null;
        period_start?: number | null;
        period_end?: number | null;
    } | null;
    stripeInvoiceItems?: Array<{
        __typename?: "StripeInvoiceItem";
        id?: string | null;
        amount?: number | null;
        amount_excluding_tax?: number | null;
        currency?: string | null;
        description?: string | null;
        type?: string | null;
    }> | null;
};

export type UpdateClientSettingsMutationVariables = Exact<{
    clientId: Scalars["String"]["input"];
    settings: ClientSettingsInput;
}>;

export type UpdateClientSettingsMutation = {
    __typename?: "Mutation";
    updateClientSettings?: { __typename?: "Client"; id?: string | null } | null;
};

export type UpdateClientBillingMutationVariables = Exact<{
    clientId: Scalars["String"]["input"];
    billing: ClientBillingInput;
}>;

export type UpdateClientBillingMutation = {
    __typename?: "Mutation";
    updateClientBilling?: { __typename?: "Client"; id?: string | null } | null;
};

export type InviteClientUserMutationVariables = Exact<{
    clientId: Scalars["String"]["input"];
    clientUser: ClientUserInput;
    clientUserRole: ClientUserRole;
    clientUserLocale?: InputMaybe<Scalars["String"]["input"]>;
}>;

export type InviteClientUserMutation = {
    __typename?: "Mutation";
    inviteClientUser?: { __typename?: "ClientUser"; id?: string | null } | null;
};

export type RequestTenantCreationMutationVariables = Exact<{
    clientId: Scalars["String"]["input"];
    message?: InputMaybe<Scalars["String"]["input"]>;
}>;

export type RequestTenantCreationMutation = { __typename?: "Mutation"; requestTenantCreation?: string | null };

export type IssueChargeCreditsInvoiceMutationVariables = Exact<{
    clientId: Scalars["String"]["input"];
    currency: Scalars["String"]["input"];
    amountCredits: Scalars["Int"]["input"];
}>;

export type IssueChargeCreditsInvoiceMutation = {
    __typename?: "Mutation";
    issueChargeCreditsInvoice?: {
        __typename?: "Invoice";
        id?: string | null;
        createdAt?: number | null;
        type?: string | null;
        stripeInvoice?: {
            __typename?: "StripeInvoice";
            id?: string | null;
            status?: string | null;
            amount_due?: number | null;
            amount_paid?: number | null;
            amount_remaining?: number | null;
            amount_shipping?: number | null;
            total?: number | null;
            total_excluding_tax?: number | null;
            subtotal?: number | null;
            subtotal_excluding_tax?: number | null;
            tax?: number | null;
            attempt_count?: number | null;
            attempted?: boolean | null;
            auto_advance?: boolean | null;
            billing_reason?: string | null;
            collection_method?: string | null;
            created?: number | null;
            currency?: string | null;
            description?: string | null;
            due_date?: number | null;
            effective_at?: number | null;
            ending_balance?: number | null;
            footer?: string | null;
            hosted_invoice_url?: string | null;
            invoice_pdf?: string | null;
            number?: string | null;
            paid?: boolean | null;
            period_start?: number | null;
            period_end?: number | null;
        } | null;
        stripeInvoiceItems?: Array<{
            __typename?: "StripeInvoiceItem";
            id?: string | null;
            amount?: number | null;
            amount_excluding_tax?: number | null;
            currency?: string | null;
            description?: string | null;
            type?: string | null;
        }> | null;
    } | null;
};

export type ChargeCreditsMutationVariables = Exact<{
    clientId: Scalars["String"]["input"];
    currency: Scalars["String"]["input"];
    amountCredits: Scalars["Int"]["input"];
}>;

export type ChargeCreditsMutation = { __typename?: "Mutation"; chargeCredits?: string | null };

export type ClientsQueryVariables = Exact<{ [key: string]: never }>;

export type ClientsQuery = {
    __typename?: "Query";
    clients?: {
        __typename?: "ClientItems";
        items?: Array<{
            __typename?: "Client";
            role?: ClientUserRole | null;
            id?: string | null;
            name?: string | null;
            maxQuestionnaireQuestions: number;
            billing?: {
                __typename?: "ClientBilling";
                email?: string | null;
                cin?: string | null;
                tin?: string | null;
            } | null;
        }> | null;
    } | null;
};

export type ClientQueryVariables = Exact<{
    clientId: Scalars["String"]["input"];
}>;

export type ClientQuery = {
    __typename?: "Query";
    client?: {
        __typename?: "Client";
        id?: string | null;
        name?: string | null;
        maxQuestionnaireQuestions: number;
        billing?: {
            __typename?: "ClientBilling";
            name?: string | null;
            email?: string | null;
            cin?: string | null;
            tin?: string | null;
            address?: {
                __typename?: "Address";
                country?: string | null;
                postalCode?: string | null;
                city?: string | null;
                line1?: string | null;
                line2?: string | null;
            } | null;
        } | null;
    } | null;
};

export type ClientUsersQueryVariables = Exact<{
    clientId: Scalars["String"]["input"];
    nextToken?: InputMaybe<Scalars["String"]["input"]>;
}>;

export type ClientUsersQuery = {
    __typename?: "Query";
    client?: {
        __typename?: "Client";
        id?: string | null;
        users?: {
            __typename?: "ClientUserItems";
            nextToken?: string | null;
            items?: Array<{
                __typename?: "ClientUser";
                id?: string | null;
                firstName?: string | null;
                lastName?: string | null;
                email?: string | null;
                role?: ClientUserRole | null;
                locale?: string | null;
            }> | null;
        } | null;
    } | null;
};

export type ClientCreditsQueryVariables = Exact<{
    clientId: Scalars["String"]["input"];
}>;

export type ClientCreditsQuery = {
    __typename?: "Query";
    client?: {
        __typename?: "Client";
        id?: string | null;
        credits?: { __typename?: "ClientCredits"; availableBalanceCredits?: number | null } | null;
    } | null;
};

export type ClientInvoicesQueryVariables = Exact<{
    clientId: Scalars["String"]["input"];
    nextToken?: InputMaybe<Scalars["String"]["input"]>;
}>;

export type ClientInvoicesQuery = {
    __typename?: "Query";
    client?: {
        __typename?: "Client";
        id?: string | null;
        invoices?: {
            __typename?: "InvoiceItems";
            nextToken?: string | null;
            items?: Array<{
                __typename?: "Invoice";
                id?: string | null;
                createdAt?: number | null;
                type?: string | null;
                stripeInvoice?: {
                    __typename?: "StripeInvoice";
                    id?: string | null;
                    status?: string | null;
                    amount_due?: number | null;
                    amount_paid?: number | null;
                    amount_remaining?: number | null;
                    amount_shipping?: number | null;
                    total?: number | null;
                    total_excluding_tax?: number | null;
                    subtotal?: number | null;
                    subtotal_excluding_tax?: number | null;
                    tax?: number | null;
                    attempt_count?: number | null;
                    attempted?: boolean | null;
                    auto_advance?: boolean | null;
                    billing_reason?: string | null;
                    collection_method?: string | null;
                    created?: number | null;
                    currency?: string | null;
                    description?: string | null;
                    due_date?: number | null;
                    effective_at?: number | null;
                    ending_balance?: number | null;
                    footer?: string | null;
                    hosted_invoice_url?: string | null;
                    invoice_pdf?: string | null;
                    number?: string | null;
                    paid?: boolean | null;
                    period_start?: number | null;
                    period_end?: number | null;
                } | null;
                stripeInvoiceItems?: Array<{
                    __typename?: "StripeInvoiceItem";
                    id?: string | null;
                    amount?: number | null;
                    amount_excluding_tax?: number | null;
                    currency?: string | null;
                    description?: string | null;
                    type?: string | null;
                }> | null;
            }> | null;
        } | null;
        users?: { __typename?: "ClientUserItems"; nextToken?: string | null } | null;
    } | null;
};

export type ClientTenantsQueryVariables = Exact<{
    clientId: Scalars["String"]["input"];
    nextToken?: InputMaybe<Scalars["String"]["input"]>;
}>;

export type ClientTenantsQuery = {
    __typename?: "Query";
    client?: {
        __typename?: "Client";
        id?: string | null;
        tenants?: {
            __typename?: "TenantItems";
            nextToken?: string | null;
            items?: Array<{
                __typename?: "Tenant";
                id?: string | null;
                tenantId?: string | null;
                type?: TenantType | null;
                locale?: string | null;
                domainName?: string | null;
                name?: string | null;
                logo?: { __typename?: "File"; src?: string | null } | null;
            }> | null;
        } | null;
    } | null;
};

export type ClientTenantQueryVariables = Exact<{
    clientId: Scalars["String"]["input"];
    tenantId?: InputMaybe<Scalars["String"]["input"]>;
}>;

export type ClientTenantQuery = {
    __typename?: "Query";
    client?: {
        __typename?: "Client";
        id?: string | null;
        tenant?: {
            __typename?: "Tenant";
            id?: string | null;
            type?: TenantType | null;
            tenantId?: string | null;
            locale?: string | null;
            domainName?: string | null;
            name?: string | null;
            campaignPrivacyConsentText?: string | null;
            campaignMarketingConsentText?: string | null;
            logo?: { __typename?: "File"; src?: string | null } | null;
            stamp?: {
                __typename?: "TenantStamp";
                width?: number | null;
                height?: number | null;
                rotationDeg?: number | null;
                ratingTop?: number | null;
                ratingHeight?: number | null;
                ratingFont?: string | null;
                ratingColor?: string | null;
                file?: {
                    __typename?: "File";
                    id?: string | null;
                    objectKey?: string | null;
                    src?: string | null;
                } | null;
            } | null;
            config?: {
                __typename?: "TenantConfig";
                theme?: {
                    __typename?: "TenantTheme";
                    colorScheme?: {
                        __typename?: "TenantThemeColorScheme";
                        primary?: string | null;
                        secondary?: string | null;
                    } | null;
                    favIcon?: {
                        __typename?: "TenantThemeFavIcon";
                        file?: { __typename?: "File"; id?: string | null; src?: string | null } | null;
                    } | null;
                } | null;
                layout?: {
                    __typename?: "TenantLayout";
                    template?: TenantLayoutTemplate | null;
                    config?: string | null;
                } | null;
                notifications?: {
                    __typename?: "TenantNotificationsConfig";
                    mailgunDomain?: string | null;
                    defaultFrom?: string | null;
                    settings?: {
                        __typename?: "TenantNotificationSettings";
                        enableWelcomeEmail?: boolean | null;
                        enableBlacklistNotification?: boolean | null;
                        enableUnblacklistNotification?: boolean | null;
                        enableCampaignApplicationSelectedNotification?: boolean | null;
                        enableCampaignApplicationAlternateNotification?: boolean | null;
                        enableCampaignApplicationRejectedNotification?: boolean | null;
                        enableDueReviewNotification?: boolean | null;
                        enableOverdueReviewNotification?: boolean | null;
                        enableReviewApprovedNotification?: boolean | null;
                        enableReviewRejectedNotification?: boolean | null;
                        dueReviewNotificationDays?: Array<number> | null;
                    } | null;
                } | null;
                reviewDestinations?: Array<{
                    __typename?: "ReviewDestination";
                    type?: string | null;
                    name?: string | null;
                    config?: string | null;
                    configFields?: Array<{
                        __typename?: "ReviewDestinationConfigField";
                        type?: ReviewDestinationConfigFieldType | null;
                        path?: string | null;
                        label?: string | null;
                        placeholder?: string | null;
                        isRequiredForApproval?: boolean | null;
                        urlStripQueryString?: boolean | null;
                    }> | null;
                }> | null;
                seo?: {
                    __typename?: "TenantSEOConfig";
                    gtmId?: string | null;
                    gtmLoadAfterInteractive?: boolean | null;
                    customScriptHead?: string | null;
                } | null;
            } | null;
        } | null;
    } | null;
};

export type ExportCampaignResultsMutationVariables = Exact<{
    clientId: Scalars["String"]["input"];
    campaignId: Scalars["String"]["input"];
    params: ExportCampaignResultsParamsInput;
}>;

export type ExportCampaignResultsMutation = { __typename?: "Mutation"; exportCampaignResults?: string | null };

export type UploadImageMutationVariables = Exact<{
    filename: Scalars["String"]["input"];
}>;

export type UploadImageMutation = {
    __typename?: "Mutation";
    uploadImage?: {
        __typename?: "File";
        id?: string | null;
        objectKey?: string | null;
        src?: string | null;
        presignedUploadUrl?: string | null;
    } | null;
};

export type DuplicateImageMutationVariables = Exact<{
    id: Scalars["String"]["input"];
}>;

export type DuplicateImageMutation = {
    __typename?: "Mutation";
    duplicateImage?: { __typename?: "File"; id?: string | null; objectKey?: string | null; src?: string | null } | null;
};

export type ManufacturersQueryVariables = Exact<{
    nextToken?: InputMaybe<Scalars["String"]["input"]>;
}>;

export type ManufacturersQuery = {
    __typename?: "Query";
    manufacturers?: {
        __typename?: "ManufacturerItems";
        nextToken?: string | null;
        items?: Array<{
            __typename?: "Manufacturer";
            id?: string | null;
            name?: string | null;
            logo?: { __typename?: "File"; src?: string | null } | null;
        }> | null;
    } | null;
};

export type ManufacturerQueryVariables = Exact<{
    manufacturerId: Scalars["String"]["input"];
}>;

export type ManufacturerQuery = {
    __typename?: "Query";
    manufacturer?: {
        __typename?: "Manufacturer";
        id?: string | null;
        name?: string | null;
        logo?: { __typename?: "File"; src?: string | null } | null;
    } | null;
};

export type ProductAttributesQueryVariables = Exact<{
    locale?: InputMaybe<Scalars["String"]["input"]>;
    limit?: InputMaybe<Scalars["Int"]["input"]>;
    nextToken?: InputMaybe<Scalars["String"]["input"]>;
}>;

export type ProductAttributesQuery = {
    __typename?: "Query";
    productAttributes?: {
        __typename?: "ProductAttributeItems";
        nextToken?: string | null;
        items?: Array<{
            __typename?: "ProductAttribute";
            id?: string | null;
            locales?: Array<string> | null;
            name?: string | null;
        }> | null;
    } | null;
};

export type ProductAttributeQueryVariables = Exact<{
    productAttributeId: Scalars["String"]["input"];
    locale?: InputMaybe<Scalars["String"]["input"]>;
}>;

export type ProductAttributeQuery = {
    __typename?: "Query";
    productAttribute?: {
        __typename?: "ProductAttribute";
        id?: string | null;
        locale?: string | null;
        locales?: Array<string> | null;
        fallbackLocale?: string | null;
        name?: string | null;
        nameLocales?: Array<{
            __typename?: "ProductAttributeNameLocale";
            locale?: string | null;
            name?: string | null;
        }> | null;
    } | null;
};

export type ProductCategoriesQueryVariables = Exact<{
    limit?: InputMaybe<Scalars["Int"]["input"]>;
    nextToken?: InputMaybe<Scalars["String"]["input"]>;
}>;

export type ProductCategoriesQuery = {
    __typename?: "Query";
    productCategories?: {
        __typename?: "ProductCategoryItems";
        nextToken?: string | null;
        items?: Array<{ __typename?: "ProductCategory"; key?: string | null }> | null;
    } | null;
};

export type ProductByEanQueryVariables = Exact<{
    ean: Scalars["String"]["input"];
    excludeProductId?: InputMaybe<Scalars["String"]["input"]>;
    locale?: InputMaybe<Scalars["String"]["input"]>;
}>;

export type ProductByEanQuery = {
    __typename?: "Query";
    productByEAN?: {
        __typename?: "Product";
        id?: string | null;
        locales?: Array<string> | null;
        fallbackLocale?: string | null;
        locale?: string | null;
        isLocalized?: boolean | null;
        name?: string | null;
        slug?: string | null;
        category?: { __typename?: "ProductCategory"; key?: string | null } | null;
        codes?: { __typename?: "ProductCodes"; ean?: string | null } | null;
        info?: {
            __typename?: "ProductInfo";
            model?: string | null;
            manufacturer?: {
                __typename?: "Manufacturer";
                id?: string | null;
                name?: string | null;
                logo?: { __typename?: "File"; src?: string | null } | null;
            } | null;
        } | null;
        thumbnailImage?: { __typename?: "File"; id?: string | null; src?: string | null } | null;
    } | null;
};

export type ReviewDestinationConfigFieldsFragment = {
    __typename?: "ReviewDestinationConfigField";
    type?: ReviewDestinationConfigFieldType | null;
    path?: string | null;
    label?: string | null;
    placeholder?: string | null;
    isRequiredForApproval?: boolean | null;
    urlStripQueryString?: boolean | null;
};

export type ReviewItemFieldsFragment = {
    __typename?: "Review";
    id?: string | null;
    lang?: string | null;
    state?: ReviewState | null;
    pros?: Array<string> | null;
    cons?: Array<string> | null;
    wouldRecommend?: boolean | null;
    wouldRecommendPercent?: number | null;
    totalRating?: number | null;
    imagesCount?: number | null;
    rejectionMessage?: string | null;
    censureMessage?: string | null;
    commentsCount?: number | null;
    contents?: Array<{
        __typename?: "ReviewContent";
        content?: string | null;
        destination?: {
            __typename?: "ReviewDestination";
            type?: string | null;
            key?: string | null;
            name?: string | null;
        } | null;
    }> | null;
    attributeRatings?: Array<{
        __typename?: "ProductAttributeRating";
        id?: string | null;
        name?: string | null;
        rating?: number | null;
    }> | null;
    images?: Array<{ __typename?: "File"; id?: string | null; src?: string | null }> | null;
    reviewer?: {
        __typename?: "Reviewer";
        id?: string | null;
        email?: string | null;
        profile?: {
            __typename?: "ReviewerProfile";
            firstName?: string | null;
            lastName?: string | null;
            gender?: Gender | null;
            birthDate?: number | null;
        } | null;
        profileImage?: { __typename?: "File"; id?: string | null; src?: string | null } | null;
    } | null;
    campaign?: {
        __typename?: "Campaign";
        id?: string | null;
        name?: string | null;
        slug?: string | null;
        thumbnailImage?: { __typename?: "File"; id?: string | null; src?: string | null } | null;
    } | null;
    product?: {
        __typename?: "Product";
        id?: string | null;
        name?: string | null;
        image?: { __typename?: "File"; id?: string | null; src?: string | null } | null;
    } | null;
};

export type ApproveReviewMutationVariables = Exact<{
    clientId: Scalars["String"]["input"];
    reviewId: Scalars["String"]["input"];
}>;

export type ApproveReviewMutation = {
    __typename?: "Mutation";
    approveReview?: { __typename?: "Review"; id?: string | null; state?: ReviewState | null } | null;
};

export type SendReviewCommentMutationVariables = Exact<{
    clientId: Scalars["String"]["input"];
    reviewId: Scalars["String"]["input"];
    content: Scalars["String"]["input"];
}>;

export type SendReviewCommentMutation = {
    __typename?: "Mutation";
    sendReviewComment?: { __typename?: "Review"; id?: string | null } | null;
};

export type CampaignReviewsQueryVariables = Exact<{
    campaignId: Scalars["String"]["input"];
    productId: Scalars["String"]["input"];
    nextToken?: InputMaybe<Scalars["String"]["input"]>;
    limit?: InputMaybe<Scalars["Int"]["input"]>;
    state?: InputMaybe<Array<ReviewState> | ReviewState>;
}>;

export type CampaignReviewsQuery = {
    __typename?: "Query";
    campaign?: {
        __typename?: "Campaign";
        id?: string | null;
        reviews?: {
            __typename?: "ReviewItems";
            nextToken?: string | null;
            items?: Array<{
                __typename?: "Review";
                id?: string | null;
                lang?: string | null;
                state?: ReviewState | null;
                pros?: Array<string> | null;
                cons?: Array<string> | null;
                wouldRecommend?: boolean | null;
                wouldRecommendPercent?: number | null;
                totalRating?: number | null;
                imagesCount?: number | null;
                rejectionMessage?: string | null;
                censureMessage?: string | null;
                commentsCount?: number | null;
                contents?: Array<{
                    __typename?: "ReviewContent";
                    content?: string | null;
                    destination?: {
                        __typename?: "ReviewDestination";
                        type?: string | null;
                        key?: string | null;
                        name?: string | null;
                    } | null;
                }> | null;
                attributeRatings?: Array<{
                    __typename?: "ProductAttributeRating";
                    id?: string | null;
                    name?: string | null;
                    rating?: number | null;
                }> | null;
                images?: Array<{ __typename?: "File"; id?: string | null; src?: string | null }> | null;
                reviewer?: {
                    __typename?: "Reviewer";
                    id?: string | null;
                    email?: string | null;
                    profile?: {
                        __typename?: "ReviewerProfile";
                        firstName?: string | null;
                        lastName?: string | null;
                        gender?: Gender | null;
                        birthDate?: number | null;
                    } | null;
                    profileImage?: { __typename?: "File"; id?: string | null; src?: string | null } | null;
                } | null;
                campaign?: {
                    __typename?: "Campaign";
                    id?: string | null;
                    name?: string | null;
                    slug?: string | null;
                    thumbnailImage?: { __typename?: "File"; id?: string | null; src?: string | null } | null;
                } | null;
                product?: {
                    __typename?: "Product";
                    id?: string | null;
                    name?: string | null;
                    image?: { __typename?: "File"; id?: string | null; src?: string | null } | null;
                } | null;
            }> | null;
        } | null;
    } | null;
};

export type ReviewCommentsQueryVariables = Exact<{
    clientId: Scalars["String"]["input"];
    reviewId: Scalars["String"]["input"];
}>;

export type ReviewCommentsQuery = {
    __typename?: "Query";
    review?: {
        __typename?: "Review";
        id?: string | null;
        comments?: {
            __typename?: "ReviewCommentItems";
            items?: Array<{
                __typename?: "ReviewComment";
                sentAt?: number | null;
                content?: string | null;
                author?: {
                    __typename?: "User";
                    id?: string | null;
                    userType?: string | null;
                    user?:
                        | {
                              __typename: "ClientUser";
                              email?: string | null;
                              firstName?: string | null;
                              lastName?: string | null;
                          }
                        | {
                              __typename: "CognitoUser";
                              Attributes?: Array<{
                                  __typename?: "CognitoUserAttribute";
                                  Name?: string | null;
                                  Value?: string | null;
                              }> | null;
                          }
                        | null;
                } | null;
            }> | null;
        } | null;
    } | null;
};

export type ExportJobFieldsFragment = {
    __typename?: "ExportJob";
    id?: string | null;
    paramsJson?: string | null;
    state?: string | null;
    startedAt?: number | null;
    finishedAt?: number | null;
    objectKey?: string | null;
    downloadUrl?: string | null;
    errorJson?: string | null;
    stats?: { __typename?: "ExportJobStats"; originalBytes?: number | null; compressedBytes?: number | null } | null;
};

export type DownloadExportJobMutationVariables = Exact<{
    jobId: Scalars["String"]["input"];
}>;

export type DownloadExportJobMutation = { __typename?: "Mutation"; downloadExportJob?: string | null };

export type SystemCreditCurrencyConversionRatesQueryVariables = Exact<{
    clientId: Scalars["String"]["input"];
}>;

export type SystemCreditCurrencyConversionRatesQuery = {
    __typename?: "Query";
    system?: {
        __typename?: "System";
        creditCurrencyConversionRates?: {
            __typename?: "CreditCurrencyConversionRates";
            rates?: Array<{
                __typename?: "CreditCurrencyConversionRate";
                currency?: string | null;
                amountPerCredit?: number | null;
            }> | null;
        } | null;
    } | null;
};

export type OnExportJobUpdateSubscriptionVariables = Exact<{
    jobId: Scalars["String"]["input"];
}>;

export type OnExportJobUpdateSubscription = {
    __typename?: "Subscription";
    onExportJobUpdate?: {
        __typename?: "ExportJobUpdate";
        jobId?: string | null;
        job?: {
            __typename?: "ExportJob";
            id?: string | null;
            state?: string | null;
            startedAt?: number | null;
            finishedAt?: number | null;
            downloadUrl?: string | null;
        } | null;
    } | null;
};

export type TenantItemFieldsFragment = {
    __typename?: "Tenant";
    id?: string | null;
    tenantId?: string | null;
    type?: TenantType | null;
    locale?: string | null;
    domainName?: string | null;
    name?: string | null;
    logo?: { __typename?: "File"; src?: string | null } | null;
};

export type TenantDetailFieldsFragment = {
    __typename?: "Tenant";
    id?: string | null;
    type?: TenantType | null;
    tenantId?: string | null;
    locale?: string | null;
    domainName?: string | null;
    name?: string | null;
    campaignPrivacyConsentText?: string | null;
    campaignMarketingConsentText?: string | null;
    logo?: { __typename?: "File"; src?: string | null } | null;
    stamp?: {
        __typename?: "TenantStamp";
        width?: number | null;
        height?: number | null;
        rotationDeg?: number | null;
        ratingTop?: number | null;
        ratingHeight?: number | null;
        ratingFont?: string | null;
        ratingColor?: string | null;
        file?: { __typename?: "File"; id?: string | null; objectKey?: string | null; src?: string | null } | null;
    } | null;
    config?: {
        __typename?: "TenantConfig";
        theme?: {
            __typename?: "TenantTheme";
            colorScheme?: {
                __typename?: "TenantThemeColorScheme";
                primary?: string | null;
                secondary?: string | null;
            } | null;
            favIcon?: {
                __typename?: "TenantThemeFavIcon";
                file?: { __typename?: "File"; id?: string | null; src?: string | null } | null;
            } | null;
        } | null;
        layout?: { __typename?: "TenantLayout"; template?: TenantLayoutTemplate | null; config?: string | null } | null;
        notifications?: {
            __typename?: "TenantNotificationsConfig";
            mailgunDomain?: string | null;
            defaultFrom?: string | null;
            settings?: {
                __typename?: "TenantNotificationSettings";
                enableWelcomeEmail?: boolean | null;
                enableBlacklistNotification?: boolean | null;
                enableUnblacklistNotification?: boolean | null;
                enableCampaignApplicationSelectedNotification?: boolean | null;
                enableCampaignApplicationAlternateNotification?: boolean | null;
                enableCampaignApplicationRejectedNotification?: boolean | null;
                enableDueReviewNotification?: boolean | null;
                enableOverdueReviewNotification?: boolean | null;
                enableReviewApprovedNotification?: boolean | null;
                enableReviewRejectedNotification?: boolean | null;
                dueReviewNotificationDays?: Array<number> | null;
            } | null;
        } | null;
        reviewDestinations?: Array<{
            __typename?: "ReviewDestination";
            type?: string | null;
            name?: string | null;
            config?: string | null;
            configFields?: Array<{
                __typename?: "ReviewDestinationConfigField";
                type?: ReviewDestinationConfigFieldType | null;
                path?: string | null;
                label?: string | null;
                placeholder?: string | null;
                isRequiredForApproval?: boolean | null;
                urlStripQueryString?: boolean | null;
            }> | null;
        }> | null;
        seo?: {
            __typename?: "TenantSEOConfig";
            gtmId?: string | null;
            gtmLoadAfterInteractive?: boolean | null;
            customScriptHead?: string | null;
        } | null;
    } | null;
};

export type UpdateTenantNameMutationVariables = Exact<{
    clientId: Scalars["String"]["input"];
    tenantId: Scalars["String"]["input"];
    name: Scalars["String"]["input"];
}>;

export type UpdateTenantNameMutation = {
    __typename?: "Mutation";
    updateTenantName?: { __typename?: "Tenant"; id?: string | null } | null;
};

export type AttachTenantLogoMutationVariables = Exact<{
    clientId: Scalars["String"]["input"];
    tenantId: Scalars["String"]["input"];
    imageId: Scalars["String"]["input"];
}>;

export type AttachTenantLogoMutation = {
    __typename?: "Mutation";
    attachTenantLogo?: { __typename?: "Tenant"; id?: string | null } | null;
};

export type UpdateTenantSeoMutationVariables = Exact<{
    clientId: Scalars["String"]["input"];
    tenantId: Scalars["String"]["input"];
    seo: TenantSeoConfigInput;
}>;

export type UpdateTenantSeoMutation = {
    __typename?: "Mutation";
    updateTenantSEO?: { __typename?: "Tenant"; id?: string | null } | null;
};

export type TenantsQueryVariables = Exact<{
    tenant?: InputMaybe<Array<Scalars["String"]["input"]> | Scalars["String"]["input"]>;
    type?: InputMaybe<Array<TenantType> | TenantType>;
    locale?: InputMaybe<Array<Scalars["String"]["input"]> | Scalars["String"]["input"]>;
    limit?: InputMaybe<Scalars["Int"]["input"]>;
    nextToken?: InputMaybe<Scalars["String"]["input"]>;
}>;

export type TenantsQuery = {
    __typename?: "Query";
    tenants?: {
        __typename?: "TenantItems";
        nextToken?: string | null;
        items?: Array<{
            __typename?: "Tenant";
            id?: string | null;
            tenantId?: string | null;
            type?: TenantType | null;
            locale?: string | null;
            domainName?: string | null;
            name?: string | null;
            logo?: { __typename?: "File"; src?: string | null } | null;
        }> | null;
    } | null;
};

export type TenantQueryVariables = Exact<{
    tenantId: Scalars["String"]["input"];
}>;

export type TenantQuery = {
    __typename?: "Query";
    tenant?: {
        __typename?: "Tenant";
        id?: string | null;
        type?: TenantType | null;
        tenantId?: string | null;
        locale?: string | null;
        domainName?: string | null;
        name?: string | null;
        logo?: { __typename?: "File"; src?: string | null } | null;
        stamp?: { __typename?: "TenantStamp"; file?: { __typename?: "File"; src?: string | null } | null } | null;
        config?: {
            __typename?: "TenantConfig";
            reviewDestinations?: Array<{
                __typename?: "ReviewDestination";
                type?: string | null;
                key?: string | null;
                name?: string | null;
                config?: string | null;
                isOrderNumber?: boolean | null;
                configFields?: Array<{
                    __typename?: "ReviewDestinationConfigField";
                    type?: ReviewDestinationConfigFieldType | null;
                    path?: string | null;
                    label?: string | null;
                    placeholder?: string | null;
                    isRequiredForApproval?: boolean | null;
                    urlStripQueryString?: boolean | null;
                }> | null;
            }> | null;
        } | null;
    } | null;
};

export type TenantReviewDestinationsQueryVariables = Exact<{
    tenantId: Scalars["String"]["input"];
}>;

export type TenantReviewDestinationsQuery = {
    __typename?: "Query";
    tenant?: {
        __typename?: "Tenant";
        id?: string | null;
        config?: {
            __typename?: "TenantConfig";
            reviewDestinations?: Array<{
                __typename?: "ReviewDestination";
                type?: string | null;
                key?: string | null;
                name?: string | null;
                config?: string | null;
                isOrderNumber?: boolean | null;
                configFields?: Array<{
                    __typename?: "ReviewDestinationConfigField";
                    type?: ReviewDestinationConfigFieldType | null;
                    path?: string | null;
                    label?: string | null;
                    placeholder?: string | null;
                    isRequiredForApproval?: boolean | null;
                    urlStripQueryString?: boolean | null;
                }> | null;
            }> | null;
        } | null;
    } | null;
};

export class TypedDocumentString<TResult, TVariables>
    extends String
    implements DocumentTypeDecoration<TResult, TVariables>
{
    __apiType?: DocumentTypeDecoration<TResult, TVariables>["__apiType"];
    private value: string;
    public __meta__?: Record<string, any> | undefined;

    constructor(value: string, __meta__?: Record<string, any> | undefined) {
        super(value);
        this.value = value;
        this.__meta__ = __meta__;
    }

    toString(): string & DocumentTypeDecoration<TResult, TVariables> {
        return this.value;
    }
}
export const AgreementItemFieldsFragmentDoc = new TypedDocumentString(
    `
    fragment agreementItemFields on Agreement {
  id
  type
  name
  currentRevisionIndex
  latestRevisionIndex
  currentRevision {
    index
    createdAt
    label
    isOptional
    isPreselected
  }
  revisions {
    index
    createdAt
  }
}
    `,
    { fragmentName: "agreementItemFields" }
) as unknown as TypedDocumentString<AgreementItemFieldsFragment, unknown>;
export const AgreementDetailFieldsFragmentDoc = new TypedDocumentString(
    `
    fragment agreementDetailFields on Agreement {
  id
  type
  name
  currentRevisionIndex
  latestRevisionIndex
  currentRevision {
    index
    createdAt
    label
    isOptional
    isPreselected
    content {
      json
    }
  }
  revisions {
    index
    createdAt
    label
    isOptional
    isPreselected
  }
}
    `,
    { fragmentName: "agreementDetailFields" }
) as unknown as TypedDocumentString<AgreementDetailFieldsFragment, unknown>;
export const ApiKeyFieldsFragmentDoc = new TypedDocumentString(
    `
    fragment apiKeyFields on APIKey {
  id
  name
  value
  createdAt
  expiresAt
}
    `,
    { fragmentName: "apiKeyFields" }
) as unknown as TypedDocumentString<ApiKeyFieldsFragment, unknown>;
export const CampaignInquiryItemFieldsFragmentDoc = new TypedDocumentString(
    `
    fragment campaignInquiryItemFields on CampaignInquiry {
  id
  createdAt
  name
  settings {
    capacity
    openAt
  }
  client {
    id
    name
  }
  tenant {
    id
    name
    domainName
    locale
    logo {
      src
    }
  }
  displayTenants {
    id
    name
    domainName
    locale
    logo {
      src
    }
  }
  mainTenant {
    id
    name
    domainName
    locale
    logo {
      src
    }
  }
  products {
    key
    id
    name
  }
}
    `,
    { fragmentName: "campaignInquiryItemFields" }
) as unknown as TypedDocumentString<CampaignInquiryItemFieldsFragment, unknown>;
export const CampaignInquiryDetailFieldsFragmentDoc = new TypedDocumentString(
    `
    fragment campaignInquiryDetailFields on CampaignInquiry {
  id
  createdAt
  name
  additionalNotes
  settings {
    capacity
    openAt
  }
  tags {
    key
    text
    color
  }
  description {
    images {
      id
      src
      objectKey
    }
    json
  }
  client {
    id
    name
  }
  tenant {
    id
    name
    domainName
    locale
    logo {
      src
    }
  }
  displayTenants {
    id
    name
    domainName
    locale
    logo {
      src
    }
  }
  mainTenant {
    id
    name
    domainName
    locale
    logo {
      src
    }
  }
  products {
    key
    id
    ean
    name
    userManualLink
    category {
      key
      parent {
        key
      }
    }
    info {
      manufacturer
      model
    }
    description {
      json
      images {
        id
        objectKey
        src
      }
    }
    destinations {
      type
      key
      name
      config
      configFields {
        type
        path
        label
        placeholder
        isRequiredForApproval
        urlStripQueryString
      }
      isOrderNumber
    }
    detailPageLinks {
      label
      src
    }
    reviewFocusInstructions {
      json
      images {
        id
        src
        objectKey
      }
    }
    images {
      id
      src
      objectKey
    }
    attributes {
      id
      name
      locale
    }
    thumbnailImage {
      id
      objectKey
      src
    }
  }
  delivery {
    instructions {
      images {
        id
        src
        objectKey
      }
      json
    }
    freeOfCharge
    type
    notes
  }
  pricing {
    isFree
    discountPercent
    discountCodes {
      items {
        code
      }
    }
  }
  outcome {
    includeImages
    includeVideo
    includeSocialPosts
    hashtags
    fbMentions
    igMentions
  }
  questionnaire {
    id
    criteria {
      dependsOn
      note
      requiredValue
      type
    }
    questions {
      key
      type
      isOptional
      text
      condition {
        dependsOn
        requiredValue
        type
      }
      options {
        key
        text
      }
    }
  }
  images {
    file {
      id
      src
      objectKey
    }
  }
  restrictions {
    ageMax
    ageMin
    gender
    location {
      city
      country
      postalCode
      line1
      line2
      postalCode
    }
  }
  thumbnailImage {
    id
    src
    objectKey
  }
}
    `,
    { fragmentName: "campaignInquiryDetailFields" }
) as unknown as TypedDocumentString<CampaignInquiryDetailFieldsFragment, unknown>;
export const CampaignItemFieldsFragmentDoc = new TypedDocumentString(
    `
    fragment campaignItemFields on Campaign {
  id
  state
  slug
  name
  tenant {
    id
    locale
    name
    domainName
  }
  displayTenants {
    id
    locale
    name
    domainName
  }
  mainTenant {
    id
    locale
    name
    domainName
  }
  products {
    id
    name
    category {
      key
    }
    info {
      manufacturer {
        id
        name
        logo {
          src
        }
      }
      model
    }
  }
  settings {
    capacity
    openAt
    closeAt
    registrationPeriodDays
    submissionPeriodDays
  }
  thumbnailImage {
    id
    src
  }
  totalApplicationsCount
  unresolvedApplicationsCount
  selectedApplicationsCount
}
    `,
    { fragmentName: "campaignItemFields" }
) as unknown as TypedDocumentString<CampaignItemFieldsFragment, unknown>;
export const CampaignDetailFieldsFragmentDoc = new TypedDocumentString(
    `
    fragment campaignDetailFields on Campaign {
  id
  state
  slug
  name
  isHidden
  isTopped
  client {
    id
    name
  }
  tenant {
    id
    locale
    name
    domainName
  }
  displayTenants {
    id
    locale
    name
    domainName
  }
  mainTenant {
    id
    locale
    name
    domainName
  }
  products {
    id
    name
    codes {
      ean
    }
    images {
      id
      objectKey
      src
    }
    category {
      key
      parent {
        key
      }
    }
    attributes {
      id
      name
      locale
    }
    info {
      manufacturer {
        id
        name
        logo {
          src
        }
      }
      model
    }
    thumbnailImage {
      id
      src
    }
    description {
      images {
        id
        objectKey
        src
      }
      json
    }
    detailPageLinks {
      label
      src
    }
    reviewFocusInstructions {
      images {
        id
        objectKey
        src
      }
      json
    }
    thumbnailImage {
      id
      objectKey
      src
    }
    userManualLink
  }
  productReviewDestinations {
    productId
    destinations {
      type
      key
      name
      config
      configFields {
        type
        path
        label
        placeholder
        isRequiredForApproval
        urlStripQueryString
      }
      isOrderNumber
    }
  }
  tags {
    key
    text
    color
  }
  description {
    json
  }
  settings {
    capacity
    openAt
    closeAt
    registrationPeriodDays
    submissionPeriodDays
  }
  restrictions {
    gender
    ageMin
    ageMax
    location {
      country
      city
      line1
      line2
      postalCode
    }
  }
  outcome {
    includeImages
    includeVideo
    includeSocialPosts
    hashtags
    fbMentions
    igMentions
  }
  pricing {
    discountPercent
    discountCodes {
      items {
        code
      }
    }
    isFree
  }
  delivery {
    freeOfCharge
    type
    notes
    instructions {
      images {
        id
        objectKey
        src
      }
      json
    }
  }
  questionnaire {
    criteria {
      dependsOn
      note
      requiredValue
      type
    }
    id
    questions {
      key
      condition {
        dependsOn
        requiredValue
        type
      }
      isOptional
      key
      options {
        key
        text
      }
      text
      type
    }
  }
  thumbnailImage {
    id
    objectKey
    src
  }
  images {
    file {
      id
      objectKey
      src
    }
  }
  attachments {
    originalFilename
    file {
      id
      src
    }
  }
  milestones {
    type
    timestamp
  }
  results {
    products {
      productId
      approvedCount
      rejectedCount
      censuredCount
      wouldRecommendCount
      wouldRecommendPercent
      totalRating
      totalRatingBreakup {
        rating
        count
      }
      attributeRatings {
        id
        name
        rating
      }
    }
  }
  totalApplicationsCount
  unresolvedApplicationsCount
  selectedApplicationsCount
  clientNote
}
    `,
    { fragmentName: "campaignDetailFields" }
) as unknown as TypedDocumentString<CampaignDetailFieldsFragment, unknown>;
export const ClientItemFieldsFragmentDoc = new TypedDocumentString(
    `
    fragment clientItemFields on Client {
  id
  name
  maxQuestionnaireQuestions
  billing {
    email
    cin
    tin
  }
}
    `,
    { fragmentName: "clientItemFields" }
) as unknown as TypedDocumentString<ClientItemFieldsFragment, unknown>;
export const ClientDetailFieldsFragmentDoc = new TypedDocumentString(
    `
    fragment clientDetailFields on Client {
  id
  name
  maxQuestionnaireQuestions
  billing {
    name
    email
    cin
    tin
    address {
      country
      postalCode
      city
      line1
      line2
    }
  }
}
    `,
    { fragmentName: "clientDetailFields" }
) as unknown as TypedDocumentString<ClientDetailFieldsFragment, unknown>;
export const ClientUserFieldsFragmentDoc = new TypedDocumentString(
    `
    fragment clientUserFields on ClientUser {
  id
  firstName
  lastName
  email
  role
  locale
}
    `,
    { fragmentName: "clientUserFields" }
) as unknown as TypedDocumentString<ClientUserFieldsFragment, unknown>;
export const StripeInvoiceFieldsFragmentDoc = new TypedDocumentString(
    `
    fragment stripeInvoiceFields on StripeInvoice {
  id
  status
  amount_due
  amount_paid
  amount_remaining
  amount_shipping
  total
  total_excluding_tax
  subtotal
  subtotal_excluding_tax
  tax
  attempt_count
  attempted
  auto_advance
  billing_reason
  collection_method
  created
  currency
  description
  due_date
  effective_at
  ending_balance
  footer
  hosted_invoice_url
  invoice_pdf
  number
  paid
  period_start
  period_end
}
    `,
    { fragmentName: "stripeInvoiceFields" }
) as unknown as TypedDocumentString<StripeInvoiceFieldsFragment, unknown>;
export const StripeInvoiceItemFieldsFragmentDoc = new TypedDocumentString(
    `
    fragment stripeInvoiceItemFields on StripeInvoiceItem {
  id
  amount
  amount_excluding_tax
  currency
  description
  type
}
    `,
    { fragmentName: "stripeInvoiceItemFields" }
) as unknown as TypedDocumentString<StripeInvoiceItemFieldsFragment, unknown>;
export const InvoiceFieldsFragmentDoc = new TypedDocumentString(
    `
    fragment invoiceFields on Invoice {
  id
  createdAt
  type
  stripeInvoice {
    ...stripeInvoiceFields
  }
  stripeInvoiceItems {
    ...stripeInvoiceItemFields
  }
}
    fragment stripeInvoiceFields on StripeInvoice {
  id
  status
  amount_due
  amount_paid
  amount_remaining
  amount_shipping
  total
  total_excluding_tax
  subtotal
  subtotal_excluding_tax
  tax
  attempt_count
  attempted
  auto_advance
  billing_reason
  collection_method
  created
  currency
  description
  due_date
  effective_at
  ending_balance
  footer
  hosted_invoice_url
  invoice_pdf
  number
  paid
  period_start
  period_end
}
fragment stripeInvoiceItemFields on StripeInvoiceItem {
  id
  amount
  amount_excluding_tax
  currency
  description
  type
}`,
    { fragmentName: "invoiceFields" }
) as unknown as TypedDocumentString<InvoiceFieldsFragment, unknown>;
export const ReviewItemFieldsFragmentDoc = new TypedDocumentString(
    `
    fragment reviewItemFields on Review {
  id
  lang
  state
  pros
  cons
  wouldRecommend
  wouldRecommendPercent
  totalRating
  imagesCount
  rejectionMessage
  censureMessage
  commentsCount
  contents {
    content
    destination {
      type
      key
      name
    }
  }
  attributeRatings {
    id
    name
    rating
  }
  images {
    id
    src
  }
  reviewer {
    id
    email
    profile {
      firstName
      lastName
      gender
      birthDate
    }
    profileImage {
      id
      src
    }
  }
  campaign {
    id
    name
    slug
    thumbnailImage {
      id
      src
    }
  }
  product {
    id
    name
    image {
      id
      src
    }
  }
}
    `,
    { fragmentName: "reviewItemFields" }
) as unknown as TypedDocumentString<ReviewItemFieldsFragment, unknown>;
export const ExportJobFieldsFragmentDoc = new TypedDocumentString(
    `
    fragment exportJobFields on ExportJob {
  id
  paramsJson
  state
  startedAt
  finishedAt
  objectKey
  downloadUrl
  errorJson
  stats {
    originalBytes
    compressedBytes
  }
}
    `,
    { fragmentName: "exportJobFields" }
) as unknown as TypedDocumentString<ExportJobFieldsFragment, unknown>;
export const TenantItemFieldsFragmentDoc = new TypedDocumentString(
    `
    fragment tenantItemFields on Tenant {
  id
  tenantId
  type
  locale
  domainName
  name
  logo {
    src
  }
}
    `,
    { fragmentName: "tenantItemFields" }
) as unknown as TypedDocumentString<TenantItemFieldsFragment, unknown>;
export const ReviewDestinationConfigFieldsFragmentDoc = new TypedDocumentString(
    `
    fragment reviewDestinationConfigFields on ReviewDestinationConfigField {
  type
  path
  label
  placeholder
  isRequiredForApproval
  urlStripQueryString
}
    `,
    { fragmentName: "reviewDestinationConfigFields" }
) as unknown as TypedDocumentString<ReviewDestinationConfigFieldsFragment, unknown>;
export const TenantDetailFieldsFragmentDoc = new TypedDocumentString(
    `
    fragment tenantDetailFields on Tenant {
  id
  type
  tenantId
  locale
  domainName
  name
  campaignPrivacyConsentText
  campaignMarketingConsentText
  logo {
    src
  }
  stamp {
    width
    height
    rotationDeg
    ratingTop
    ratingHeight
    ratingFont
    ratingColor
    file {
      id
      objectKey
      src
    }
  }
  config {
    theme {
      colorScheme {
        primary
        secondary
      }
      favIcon {
        file {
          id
          src
        }
      }
    }
    layout {
      template
      config
    }
    notifications {
      mailgunDomain
      defaultFrom
      settings {
        enableWelcomeEmail
        enableBlacklistNotification
        enableUnblacklistNotification
        enableCampaignApplicationSelectedNotification
        enableCampaignApplicationAlternateNotification
        enableCampaignApplicationRejectedNotification
        enableDueReviewNotification
        enableOverdueReviewNotification
        enableReviewApprovedNotification
        enableReviewRejectedNotification
        dueReviewNotificationDays
      }
    }
    reviewDestinations {
      type
      name
      config
      configFields {
        ...reviewDestinationConfigFields
      }
    }
    seo {
      gtmId
      gtmLoadAfterInteractive
      customScriptHead
    }
  }
}
    fragment reviewDestinationConfigFields on ReviewDestinationConfigField {
  type
  path
  label
  placeholder
  isRequiredForApproval
  urlStripQueryString
}`,
    { fragmentName: "tenantDetailFields" }
) as unknown as TypedDocumentString<TenantDetailFieldsFragment, unknown>;
export const CreateApiKeyDocument = new TypedDocumentString(`
    mutation CreateAPIKey($clientId: String!, $name: String!, $expiresAt: Float) {
  createAPIKey(clientId: $clientId, name: $name, expiresAt: $expiresAt) {
    ...apiKeyFields
  }
}
    fragment apiKeyFields on APIKey {
  id
  name
  value
  createdAt
  expiresAt
}`) as unknown as TypedDocumentString<CreateApiKeyMutation, CreateApiKeyMutationVariables>;
export const DeleteApiKeyDocument = new TypedDocumentString(`
    mutation DeleteAPIKey($clientId: String!, $apiKeyId: String!) {
  deleteAPIKey(clientId: $clientId, apiKeyId: $apiKeyId) {
    ...apiKeyFields
  }
}
    fragment apiKeyFields on APIKey {
  id
  name
  value
  createdAt
  expiresAt
}`) as unknown as TypedDocumentString<DeleteApiKeyMutation, DeleteApiKeyMutationVariables>;
export const ApiKeysDocument = new TypedDocumentString(`
    query APIKeys($clientId: String!) {
  client(clientId: $clientId) {
    api {
      apiKeys {
        ...apiKeyFields
      }
    }
  }
}
    fragment apiKeyFields on APIKey {
  id
  name
  value
  createdAt
  expiresAt
}`) as unknown as TypedDocumentString<ApiKeysQuery, ApiKeysQueryVariables>;
export const ResetPasswordDocument = new TypedDocumentString(`
    mutation ResetPassword($email: String!) {
  resetPassword(email: $email)
}
    `) as unknown as TypedDocumentString<ResetPasswordMutation, ResetPasswordMutationVariables>;
export const CurrentUserDocument = new TypedDocumentString(`
    query CurrentUser {
  currentUser {
    id
    email
    firstName
    lastName
  }
}
    `) as unknown as TypedDocumentString<CurrentUserQuery, CurrentUserQueryVariables>;
export const CreateCampaignInquiryDocument = new TypedDocumentString(`
    mutation CreateCampaignInquiry($campaignInquiry: CreateCampaignInquiryInput!) {
  createCampaignInquiry(campaignInquiry: $campaignInquiry) {
    id
  }
}
    `) as unknown as TypedDocumentString<CreateCampaignInquiryMutation, CreateCampaignInquiryMutationVariables>;
export const CampaignInquiriesDocument = new TypedDocumentString(`
    query CampaignInquiries($client: String!, $resolved: Boolean, $limit: Int, $nextToken: String) {
  campaignInquiries(
    client: $client
    resolved: $resolved
    limit: $limit
    nextToken: $nextToken
  ) {
    nextToken
    items {
      ...campaignInquiryItemFields
    }
  }
}
    fragment campaignInquiryItemFields on CampaignInquiry {
  id
  createdAt
  name
  settings {
    capacity
    openAt
  }
  client {
    id
    name
  }
  tenant {
    id
    name
    domainName
    locale
    logo {
      src
    }
  }
  displayTenants {
    id
    name
    domainName
    locale
    logo {
      src
    }
  }
  mainTenant {
    id
    name
    domainName
    locale
    logo {
      src
    }
  }
  products {
    key
    id
    name
  }
}`) as unknown as TypedDocumentString<CampaignInquiriesQuery, CampaignInquiriesQueryVariables>;
export const CampaignInquiryDocument = new TypedDocumentString(`
    query CampaignInquiry($campaignInquiryId: String!) {
  campaignInquiry(campaignInquiryId: $campaignInquiryId) {
    ...campaignInquiryDetailFields
  }
}
    fragment campaignInquiryDetailFields on CampaignInquiry {
  id
  createdAt
  name
  additionalNotes
  settings {
    capacity
    openAt
  }
  tags {
    key
    text
    color
  }
  description {
    images {
      id
      src
      objectKey
    }
    json
  }
  client {
    id
    name
  }
  tenant {
    id
    name
    domainName
    locale
    logo {
      src
    }
  }
  displayTenants {
    id
    name
    domainName
    locale
    logo {
      src
    }
  }
  mainTenant {
    id
    name
    domainName
    locale
    logo {
      src
    }
  }
  products {
    key
    id
    ean
    name
    userManualLink
    category {
      key
      parent {
        key
      }
    }
    info {
      manufacturer
      model
    }
    description {
      json
      images {
        id
        objectKey
        src
      }
    }
    destinations {
      type
      key
      name
      config
      configFields {
        type
        path
        label
        placeholder
        isRequiredForApproval
        urlStripQueryString
      }
      isOrderNumber
    }
    detailPageLinks {
      label
      src
    }
    reviewFocusInstructions {
      json
      images {
        id
        src
        objectKey
      }
    }
    images {
      id
      src
      objectKey
    }
    attributes {
      id
      name
      locale
    }
    thumbnailImage {
      id
      objectKey
      src
    }
  }
  delivery {
    instructions {
      images {
        id
        src
        objectKey
      }
      json
    }
    freeOfCharge
    type
    notes
  }
  pricing {
    isFree
    discountPercent
    discountCodes {
      items {
        code
      }
    }
  }
  outcome {
    includeImages
    includeVideo
    includeSocialPosts
    hashtags
    fbMentions
    igMentions
  }
  questionnaire {
    id
    criteria {
      dependsOn
      note
      requiredValue
      type
    }
    questions {
      key
      type
      isOptional
      text
      condition {
        dependsOn
        requiredValue
        type
      }
      options {
        key
        text
      }
    }
  }
  images {
    file {
      id
      src
      objectKey
    }
  }
  restrictions {
    ageMax
    ageMin
    gender
    location {
      city
      country
      postalCode
      line1
      line2
      postalCode
    }
  }
  thumbnailImage {
    id
    src
    objectKey
  }
}`) as unknown as TypedDocumentString<CampaignInquiryQuery, CampaignInquiryQueryVariables>;
export const CampaignResultsExportJobsDocument = new TypedDocumentString(`
    query CampaignResultsExportJobs($campaignId: String!, $clientId: String!) {
  campaign(campaignId: $campaignId) {
    id
    resultsExportJobs(clientId: $clientId) {
      ...exportJobFields
    }
  }
}
    fragment exportJobFields on ExportJob {
  id
  paramsJson
  state
  startedAt
  finishedAt
  objectKey
  downloadUrl
  errorJson
  stats {
    originalBytes
    compressedBytes
  }
}`) as unknown as TypedDocumentString<CampaignResultsExportJobsQuery, CampaignResultsExportJobsQueryVariables>;
export const ApproveCampaignDocument = new TypedDocumentString(`
    mutation ApproveCampaign($campaignId: String!) {
  approveCampaign(campaignId: $campaignId) {
    id
  }
}
    `) as unknown as TypedDocumentString<ApproveCampaignMutation, ApproveCampaignMutationVariables>;
export const CampaignsDocument = new TypedDocumentString(`
    query Campaigns($client: String!, $state: CampaignState, $limit: Int, $nextToken: String) {
  campaigns(client: $client, state: $state, limit: $limit, nextToken: $nextToken) {
    nextToken
    items {
      ...campaignItemFields
    }
  }
}
    fragment campaignItemFields on Campaign {
  id
  state
  slug
  name
  tenant {
    id
    locale
    name
    domainName
  }
  displayTenants {
    id
    locale
    name
    domainName
  }
  mainTenant {
    id
    locale
    name
    domainName
  }
  products {
    id
    name
    category {
      key
    }
    info {
      manufacturer {
        id
        name
        logo {
          src
        }
      }
      model
    }
  }
  settings {
    capacity
    openAt
    closeAt
    registrationPeriodDays
    submissionPeriodDays
  }
  thumbnailImage {
    id
    src
  }
  totalApplicationsCount
  unresolvedApplicationsCount
  selectedApplicationsCount
}`) as unknown as TypedDocumentString<CampaignsQuery, CampaignsQueryVariables>;
export const CampaignDocument = new TypedDocumentString(`
    query Campaign($campaignId: String!) {
  campaign(campaignId: $campaignId) {
    ...campaignDetailFields
  }
}
    fragment campaignDetailFields on Campaign {
  id
  state
  slug
  name
  isHidden
  isTopped
  client {
    id
    name
  }
  tenant {
    id
    locale
    name
    domainName
  }
  displayTenants {
    id
    locale
    name
    domainName
  }
  mainTenant {
    id
    locale
    name
    domainName
  }
  products {
    id
    name
    codes {
      ean
    }
    images {
      id
      objectKey
      src
    }
    category {
      key
      parent {
        key
      }
    }
    attributes {
      id
      name
      locale
    }
    info {
      manufacturer {
        id
        name
        logo {
          src
        }
      }
      model
    }
    thumbnailImage {
      id
      src
    }
    description {
      images {
        id
        objectKey
        src
      }
      json
    }
    detailPageLinks {
      label
      src
    }
    reviewFocusInstructions {
      images {
        id
        objectKey
        src
      }
      json
    }
    thumbnailImage {
      id
      objectKey
      src
    }
    userManualLink
  }
  productReviewDestinations {
    productId
    destinations {
      type
      key
      name
      config
      configFields {
        type
        path
        label
        placeholder
        isRequiredForApproval
        urlStripQueryString
      }
      isOrderNumber
    }
  }
  tags {
    key
    text
    color
  }
  description {
    json
  }
  settings {
    capacity
    openAt
    closeAt
    registrationPeriodDays
    submissionPeriodDays
  }
  restrictions {
    gender
    ageMin
    ageMax
    location {
      country
      city
      line1
      line2
      postalCode
    }
  }
  outcome {
    includeImages
    includeVideo
    includeSocialPosts
    hashtags
    fbMentions
    igMentions
  }
  pricing {
    discountPercent
    discountCodes {
      items {
        code
      }
    }
    isFree
  }
  delivery {
    freeOfCharge
    type
    notes
    instructions {
      images {
        id
        objectKey
        src
      }
      json
    }
  }
  questionnaire {
    criteria {
      dependsOn
      note
      requiredValue
      type
    }
    id
    questions {
      key
      condition {
        dependsOn
        requiredValue
        type
      }
      isOptional
      key
      options {
        key
        text
      }
      text
      type
    }
  }
  thumbnailImage {
    id
    objectKey
    src
  }
  images {
    file {
      id
      objectKey
      src
    }
  }
  attachments {
    originalFilename
    file {
      id
      src
    }
  }
  milestones {
    type
    timestamp
  }
  results {
    products {
      productId
      approvedCount
      rejectedCount
      censuredCount
      wouldRecommendCount
      wouldRecommendPercent
      totalRating
      totalRatingBreakup {
        rating
        count
      }
      attributeRatings {
        id
        name
        rating
      }
    }
  }
  totalApplicationsCount
  unresolvedApplicationsCount
  selectedApplicationsCount
  clientNote
}`) as unknown as TypedDocumentString<CampaignQuery, CampaignQueryVariables>;
export const CampaignProductReviewDestinationsDocument = new TypedDocumentString(`
    query CampaignProductReviewDestinations($campaignId: String!) {
  campaign(campaignId: $campaignId) {
    id
    productReviewDestinations {
      productId
      destinations {
        type
        key
        name
        config
      }
    }
  }
}
    `) as unknown as TypedDocumentString<
    CampaignProductReviewDestinationsQuery,
    CampaignProductReviewDestinationsQueryVariables
>;
export const CampaignQuestionnaireDocument = new TypedDocumentString(`
    query CampaignQuestionnaire($campaignId: String!) {
  campaign(campaignId: $campaignId) {
    id
    questionnaire {
      id
      questions {
        key
        type
        isOptional
        text
        options {
          key
          text
        }
      }
    }
  }
}
    `) as unknown as TypedDocumentString<CampaignQuestionnaireQuery, CampaignQuestionnaireQueryVariables>;
export const OnCampaignUpdateDocument = new TypedDocumentString(`
    subscription OnCampaignUpdate($campaignId: String!) {
  onCampaignUpdate(campaignId: $campaignId) {
    campaignId
    reason
  }
}
    `) as unknown as TypedDocumentString<OnCampaignUpdateSubscription, OnCampaignUpdateSubscriptionVariables>;
export const UpdateClientSettingsDocument = new TypedDocumentString(`
    mutation UpdateClientSettings($clientId: String!, $settings: ClientSettingsInput!) {
  updateClientSettings(clientId: $clientId, settings: $settings) {
    id
  }
}
    `) as unknown as TypedDocumentString<UpdateClientSettingsMutation, UpdateClientSettingsMutationVariables>;
export const UpdateClientBillingDocument = new TypedDocumentString(`
    mutation UpdateClientBilling($clientId: String!, $billing: ClientBillingInput!) {
  updateClientBilling(clientId: $clientId, billing: $billing) {
    id
  }
}
    `) as unknown as TypedDocumentString<UpdateClientBillingMutation, UpdateClientBillingMutationVariables>;
export const InviteClientUserDocument = new TypedDocumentString(`
    mutation InviteClientUser($clientId: String!, $clientUser: ClientUserInput!, $clientUserRole: ClientUserRole!, $clientUserLocale: String) {
  inviteClientUser(
    clientId: $clientId
    clientUser: $clientUser
    clientUserRole: $clientUserRole
    clientUserLocale: $clientUserLocale
  ) {
    id
  }
}
    `) as unknown as TypedDocumentString<InviteClientUserMutation, InviteClientUserMutationVariables>;
export const RequestTenantCreationDocument = new TypedDocumentString(`
    mutation RequestTenantCreation($clientId: String!, $message: String) {
  requestTenantCreation(clientId: $clientId, message: $message)
}
    `) as unknown as TypedDocumentString<RequestTenantCreationMutation, RequestTenantCreationMutationVariables>;
export const IssueChargeCreditsInvoiceDocument = new TypedDocumentString(`
    mutation IssueChargeCreditsInvoice($clientId: String!, $currency: String!, $amountCredits: Int!) {
  issueChargeCreditsInvoice(
    clientId: $clientId
    currency: $currency
    amountCredits: $amountCredits
  ) {
    ...invoiceFields
  }
}
    fragment stripeInvoiceFields on StripeInvoice {
  id
  status
  amount_due
  amount_paid
  amount_remaining
  amount_shipping
  total
  total_excluding_tax
  subtotal
  subtotal_excluding_tax
  tax
  attempt_count
  attempted
  auto_advance
  billing_reason
  collection_method
  created
  currency
  description
  due_date
  effective_at
  ending_balance
  footer
  hosted_invoice_url
  invoice_pdf
  number
  paid
  period_start
  period_end
}
fragment stripeInvoiceItemFields on StripeInvoiceItem {
  id
  amount
  amount_excluding_tax
  currency
  description
  type
}
fragment invoiceFields on Invoice {
  id
  createdAt
  type
  stripeInvoice {
    ...stripeInvoiceFields
  }
  stripeInvoiceItems {
    ...stripeInvoiceItemFields
  }
}`) as unknown as TypedDocumentString<IssueChargeCreditsInvoiceMutation, IssueChargeCreditsInvoiceMutationVariables>;
export const ChargeCreditsDocument = new TypedDocumentString(`
    mutation chargeCredits($clientId: String!, $currency: String!, $amountCredits: Int!) {
  chargeCredits(
    clientId: $clientId
    currency: $currency
    amountCredits: $amountCredits
  )
}
    `) as unknown as TypedDocumentString<ChargeCreditsMutation, ChargeCreditsMutationVariables>;
export const ClientsDocument = new TypedDocumentString(`
    query Clients {
  clients {
    items {
      ...clientItemFields
      role
    }
  }
}
    fragment clientItemFields on Client {
  id
  name
  maxQuestionnaireQuestions
  billing {
    email
    cin
    tin
  }
}`) as unknown as TypedDocumentString<ClientsQuery, ClientsQueryVariables>;
export const ClientDocument = new TypedDocumentString(`
    query Client($clientId: String!) {
  client(clientId: $clientId) {
    ...clientDetailFields
  }
}
    fragment clientDetailFields on Client {
  id
  name
  maxQuestionnaireQuestions
  billing {
    name
    email
    cin
    tin
    address {
      country
      postalCode
      city
      line1
      line2
    }
  }
}`) as unknown as TypedDocumentString<ClientQuery, ClientQueryVariables>;
export const ClientUsersDocument = new TypedDocumentString(`
    query ClientUsers($clientId: String!, $nextToken: String) {
  client(clientId: $clientId) {
    id
    users(nextToken: $nextToken) {
      nextToken
      items {
        ...clientUserFields
      }
    }
  }
}
    fragment clientUserFields on ClientUser {
  id
  firstName
  lastName
  email
  role
  locale
}`) as unknown as TypedDocumentString<ClientUsersQuery, ClientUsersQueryVariables>;
export const ClientCreditsDocument = new TypedDocumentString(`
    query ClientCredits($clientId: String!) {
  client(clientId: $clientId) {
    id
    credits {
      availableBalanceCredits
    }
  }
}
    `) as unknown as TypedDocumentString<ClientCreditsQuery, ClientCreditsQueryVariables>;
export const ClientInvoicesDocument = new TypedDocumentString(`
    query ClientInvoices($clientId: String!, $nextToken: String) {
  client(clientId: $clientId) {
    id
    invoices(nextToken: $nextToken) {
      nextToken
      items {
        ...invoiceFields
      }
    }
    users {
      nextToken
    }
  }
}
    fragment stripeInvoiceFields on StripeInvoice {
  id
  status
  amount_due
  amount_paid
  amount_remaining
  amount_shipping
  total
  total_excluding_tax
  subtotal
  subtotal_excluding_tax
  tax
  attempt_count
  attempted
  auto_advance
  billing_reason
  collection_method
  created
  currency
  description
  due_date
  effective_at
  ending_balance
  footer
  hosted_invoice_url
  invoice_pdf
  number
  paid
  period_start
  period_end
}
fragment stripeInvoiceItemFields on StripeInvoiceItem {
  id
  amount
  amount_excluding_tax
  currency
  description
  type
}
fragment invoiceFields on Invoice {
  id
  createdAt
  type
  stripeInvoice {
    ...stripeInvoiceFields
  }
  stripeInvoiceItems {
    ...stripeInvoiceItemFields
  }
}`) as unknown as TypedDocumentString<ClientInvoicesQuery, ClientInvoicesQueryVariables>;
export const ClientTenantsDocument = new TypedDocumentString(`
    query ClientTenants($clientId: String!, $nextToken: String) {
  client(clientId: $clientId) {
    id
    tenants(nextToken: $nextToken) {
      nextToken
      items {
        ...tenantItemFields
      }
    }
  }
}
    fragment tenantItemFields on Tenant {
  id
  tenantId
  type
  locale
  domainName
  name
  logo {
    src
  }
}`) as unknown as TypedDocumentString<ClientTenantsQuery, ClientTenantsQueryVariables>;
export const ClientTenantDocument = new TypedDocumentString(`
    query ClientTenant($clientId: String!, $tenantId: String) {
  client(clientId: $clientId) {
    id
    tenant(tenantId: $tenantId) {
      ...tenantDetailFields
    }
  }
}
    fragment reviewDestinationConfigFields on ReviewDestinationConfigField {
  type
  path
  label
  placeholder
  isRequiredForApproval
  urlStripQueryString
}
fragment tenantDetailFields on Tenant {
  id
  type
  tenantId
  locale
  domainName
  name
  campaignPrivacyConsentText
  campaignMarketingConsentText
  logo {
    src
  }
  stamp {
    width
    height
    rotationDeg
    ratingTop
    ratingHeight
    ratingFont
    ratingColor
    file {
      id
      objectKey
      src
    }
  }
  config {
    theme {
      colorScheme {
        primary
        secondary
      }
      favIcon {
        file {
          id
          src
        }
      }
    }
    layout {
      template
      config
    }
    notifications {
      mailgunDomain
      defaultFrom
      settings {
        enableWelcomeEmail
        enableBlacklistNotification
        enableUnblacklistNotification
        enableCampaignApplicationSelectedNotification
        enableCampaignApplicationAlternateNotification
        enableCampaignApplicationRejectedNotification
        enableDueReviewNotification
        enableOverdueReviewNotification
        enableReviewApprovedNotification
        enableReviewRejectedNotification
        dueReviewNotificationDays
      }
    }
    reviewDestinations {
      type
      name
      config
      configFields {
        ...reviewDestinationConfigFields
      }
    }
    seo {
      gtmId
      gtmLoadAfterInteractive
      customScriptHead
    }
  }
}`) as unknown as TypedDocumentString<ClientTenantQuery, ClientTenantQueryVariables>;
export const ExportCampaignResultsDocument = new TypedDocumentString(`
    mutation ExportCampaignResults($clientId: String!, $campaignId: String!, $params: ExportCampaignResultsParamsInput!) {
  exportCampaignResults(
    clientId: $clientId
    campaignId: $campaignId
    params: $params
  )
}
    `) as unknown as TypedDocumentString<ExportCampaignResultsMutation, ExportCampaignResultsMutationVariables>;
export const UploadImageDocument = new TypedDocumentString(`
    mutation UploadImage($filename: String!) {
  uploadImage(filename: $filename) {
    id
    objectKey
    src
    presignedUploadUrl
  }
}
    `) as unknown as TypedDocumentString<UploadImageMutation, UploadImageMutationVariables>;
export const DuplicateImageDocument = new TypedDocumentString(`
    mutation DuplicateImage($id: String!) {
  duplicateImage(id: $id) {
    id
    objectKey
    src
  }
}
    `) as unknown as TypedDocumentString<DuplicateImageMutation, DuplicateImageMutationVariables>;
export const ManufacturersDocument = new TypedDocumentString(`
    query Manufacturers($nextToken: String) {
  manufacturers(nextToken: $nextToken) {
    nextToken
    items {
      id
      name
      logo {
        src
      }
    }
  }
}
    `) as unknown as TypedDocumentString<ManufacturersQuery, ManufacturersQueryVariables>;
export const ManufacturerDocument = new TypedDocumentString(`
    query Manufacturer($manufacturerId: String!) {
  manufacturer(manufacturerId: $manufacturerId) {
    id
    name
    logo {
      src
    }
  }
}
    `) as unknown as TypedDocumentString<ManufacturerQuery, ManufacturerQueryVariables>;
export const ProductAttributesDocument = new TypedDocumentString(`
    query ProductAttributes($locale: String, $limit: Int, $nextToken: String) {
  productAttributes(locale: $locale, limit: $limit, nextToken: $nextToken) {
    nextToken
    items {
      id
      locales
      name
    }
  }
}
    `) as unknown as TypedDocumentString<ProductAttributesQuery, ProductAttributesQueryVariables>;
export const ProductAttributeDocument = new TypedDocumentString(`
    query ProductAttribute($productAttributeId: String!, $locale: String) {
  productAttribute(productAttributeId: $productAttributeId, locale: $locale) {
    id
    locale
    locales
    fallbackLocale
    name
    nameLocales {
      locale
      name
    }
  }
}
    `) as unknown as TypedDocumentString<ProductAttributeQuery, ProductAttributeQueryVariables>;
export const ProductCategoriesDocument = new TypedDocumentString(`
    query ProductCategories($limit: Int, $nextToken: String) {
  productCategories(limit: $limit, nextToken: $nextToken) {
    nextToken
    items {
      key
    }
  }
}
    `) as unknown as TypedDocumentString<ProductCategoriesQuery, ProductCategoriesQueryVariables>;
export const ProductByEanDocument = new TypedDocumentString(`
    query ProductByEAN($ean: String!, $excludeProductId: String, $locale: String) {
  productByEAN(ean: $ean, excludeProductId: $excludeProductId, locale: $locale) {
    id
    locales
    fallbackLocale
    locale
    isLocalized
    name
    slug
    category {
      key
    }
    codes {
      ean
    }
    info {
      manufacturer {
        id
        name
        logo {
          src
        }
      }
      model
    }
    thumbnailImage {
      id
      src
    }
  }
}
    `) as unknown as TypedDocumentString<ProductByEanQuery, ProductByEanQueryVariables>;
export const ApproveReviewDocument = new TypedDocumentString(`
    mutation ApproveReview($clientId: String!, $reviewId: String!) {
  approveReview(clientId: $clientId, reviewId: $reviewId) {
    id
    state
  }
}
    `) as unknown as TypedDocumentString<ApproveReviewMutation, ApproveReviewMutationVariables>;
export const SendReviewCommentDocument = new TypedDocumentString(`
    mutation SendReviewComment($clientId: String!, $reviewId: String!, $content: String!) {
  sendReviewComment(clientId: $clientId, reviewId: $reviewId, content: $content) {
    id
  }
}
    `) as unknown as TypedDocumentString<SendReviewCommentMutation, SendReviewCommentMutationVariables>;
export const CampaignReviewsDocument = new TypedDocumentString(`
    query CampaignReviews($campaignId: String!, $productId: String!, $nextToken: String, $limit: Int, $state: [ReviewState!]) {
  campaign(campaignId: $campaignId) {
    id
    reviews(
      productId: $productId
      limit: $limit
      nextToken: $nextToken
      state: $state
    ) {
      nextToken
      items {
        ...reviewItemFields
      }
    }
  }
}
    fragment reviewItemFields on Review {
  id
  lang
  state
  pros
  cons
  wouldRecommend
  wouldRecommendPercent
  totalRating
  imagesCount
  rejectionMessage
  censureMessage
  commentsCount
  contents {
    content
    destination {
      type
      key
      name
    }
  }
  attributeRatings {
    id
    name
    rating
  }
  images {
    id
    src
  }
  reviewer {
    id
    email
    profile {
      firstName
      lastName
      gender
      birthDate
    }
    profileImage {
      id
      src
    }
  }
  campaign {
    id
    name
    slug
    thumbnailImage {
      id
      src
    }
  }
  product {
    id
    name
    image {
      id
      src
    }
  }
}`) as unknown as TypedDocumentString<CampaignReviewsQuery, CampaignReviewsQueryVariables>;
export const ReviewCommentsDocument = new TypedDocumentString(`
    query ReviewComments($clientId: String!, $reviewId: String!) {
  review(clientId: $clientId, reviewId: $reviewId) {
    id
    comments {
      items {
        sentAt
        content
        author {
          id
          userType
          user {
            __typename
            ... on CognitoUser {
              Attributes {
                Name
                Value
              }
            }
            ... on ClientUser {
              email
              firstName
              lastName
            }
          }
        }
      }
    }
  }
}
    `) as unknown as TypedDocumentString<ReviewCommentsQuery, ReviewCommentsQueryVariables>;
export const DownloadExportJobDocument = new TypedDocumentString(`
    mutation DownloadExportJob($jobId: String!) {
  downloadExportJob(jobId: $jobId)
}
    `) as unknown as TypedDocumentString<DownloadExportJobMutation, DownloadExportJobMutationVariables>;
export const SystemCreditCurrencyConversionRatesDocument = new TypedDocumentString(`
    query SystemCreditCurrencyConversionRates($clientId: String!) {
  system {
    creditCurrencyConversionRates(clientId: $clientId) {
      rates {
        currency
        amountPerCredit
      }
    }
  }
}
    `) as unknown as TypedDocumentString<
    SystemCreditCurrencyConversionRatesQuery,
    SystemCreditCurrencyConversionRatesQueryVariables
>;
export const OnExportJobUpdateDocument = new TypedDocumentString(`
    subscription OnExportJobUpdate($jobId: String!) {
  onExportJobUpdate(jobId: $jobId) {
    jobId
    job {
      id
      state
      startedAt
      finishedAt
      downloadUrl
    }
  }
}
    `) as unknown as TypedDocumentString<OnExportJobUpdateSubscription, OnExportJobUpdateSubscriptionVariables>;
export const UpdateTenantNameDocument = new TypedDocumentString(`
    mutation UpdateTenantName($clientId: String!, $tenantId: String!, $name: String!) {
  updateTenantName(clientId: $clientId, tenantId: $tenantId, name: $name) {
    id
  }
}
    `) as unknown as TypedDocumentString<UpdateTenantNameMutation, UpdateTenantNameMutationVariables>;
export const AttachTenantLogoDocument = new TypedDocumentString(`
    mutation AttachTenantLogo($clientId: String!, $tenantId: String!, $imageId: String!) {
  attachTenantLogo(clientId: $clientId, tenantId: $tenantId, imageId: $imageId) {
    id
  }
}
    `) as unknown as TypedDocumentString<AttachTenantLogoMutation, AttachTenantLogoMutationVariables>;
export const UpdateTenantSeoDocument = new TypedDocumentString(`
    mutation UpdateTenantSEO($clientId: String!, $tenantId: String!, $seo: TenantSEOConfigInput!) {
  updateTenantSEO(clientId: $clientId, tenantId: $tenantId, seo: $seo) {
    id
  }
}
    `) as unknown as TypedDocumentString<UpdateTenantSeoMutation, UpdateTenantSeoMutationVariables>;
export const TenantsDocument = new TypedDocumentString(`
    query Tenants($tenant: [String!], $type: [TenantType!], $locale: [String!], $limit: Int, $nextToken: String) {
  tenants(
    tenant: $tenant
    type: $type
    locale: $locale
    limit: $limit
    nextToken: $nextToken
  ) {
    nextToken
    items {
      ...tenantItemFields
    }
  }
}
    fragment tenantItemFields on Tenant {
  id
  tenantId
  type
  locale
  domainName
  name
  logo {
    src
  }
}`) as unknown as TypedDocumentString<TenantsQuery, TenantsQueryVariables>;
export const TenantDocument = new TypedDocumentString(`
    query Tenant($tenantId: String!) {
  tenant(tenantId: $tenantId) {
    id
    type
    tenantId
    locale
    domainName
    name
    logo {
      src
    }
    stamp {
      file {
        src
      }
    }
    config {
      reviewDestinations {
        type
        key
        name
        config
        configFields {
          type
          path
          label
          placeholder
          isRequiredForApproval
          urlStripQueryString
        }
        isOrderNumber
      }
    }
  }
}
    `) as unknown as TypedDocumentString<TenantQuery, TenantQueryVariables>;
export const TenantReviewDestinationsDocument = new TypedDocumentString(`
    query TenantReviewDestinations($tenantId: String!) {
  tenant(tenantId: $tenantId) {
    id
    config {
      reviewDestinations {
        type
        key
        name
        config
        configFields {
          type
          path
          label
          placeholder
          isRequiredForApproval
          urlStripQueryString
        }
        isOrderNumber
      }
    }
  }
}
    `) as unknown as TypedDocumentString<TenantReviewDestinationsQuery, TenantReviewDestinationsQueryVariables>;
